<template>
  <div class="sugestoes-feed" @touchstart="onTouchStart" @touchend="onTouchEnd">
    <!-- ==================== LEFT DRAWER (MOBILE) ==================== -->
    <Teleport to="body">
      <div v-if="!isDesktop && isLeftDrawerOpen" class="feed-drawer-backdrop" :style="{ zIndex: zIndexDrawer }" @click="closeLeftDrawer"></div>
      <aside v-if="!isDesktop" class="feed-drawer feed-drawer-left" :class="{ 'feed-drawer-open': isLeftDrawerOpen }" :style="{ zIndex: zIndexDrawer + 1 }">
        <div class="drawer-header">
          <strong class="drawer-title"><i class="bi bi-person-circle me-2"></i>Navegação</strong>
          <button class="drawer-close" @click="closeLeftDrawer"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="drawer-body">
          <!-- Perfil resumido -->
          <div class="sidebar-block sidebar-profile">
            <div class="profile-top-row">
              <div class="profile-avatar-ring">
                <div v-if="meuPerfil?.urlFotoPublica || meuPerfil?.urlFotoInterna" class="profile-avatar">
                  <img :src="meuPerfil.urlFotoPublica || meuPerfil.urlFotoInterna" alt="Avatar" class="rounded-circle" width="48" height="48" style="object-fit: cover;" />
                </div>
                <div v-else class="profile-avatar" :style="{ backgroundColor: getAvatarColor(nomeUtilizador) }">
                  {{ getAvatarInitial(nomeUtilizador) }}
                </div>
              </div>
              <BellSugestoes class="profile-bell" @abrir-sugestao="abrirSugestaoDesdeWidget($event)" />
            </div>
            <div class="profile-info">
              <strong class="profile-name">@{{ meuPerfil?.apelido || meuPerfil?.nome || nomeUtilizador }}</strong>
              <span v-if="isAdmin" class="badge badge-admin-interno">CTech</span>
            </div>
            <div class="profile-stats">
              <div class="profile-stat">
                <span class="stat-value">{{ minhasStats.totalCriadas }}</span>
                <span class="stat-label">Criadas</span>
              </div>
              <div class="profile-stat">
                <span class="stat-value">{{ minhasStats.totalVotos }}</span>
                <span class="stat-label">Votos</span>
              </div>
              <div class="profile-stat">
                <span class="stat-value">{{ minhasStats.totalComentarios }}</span>
                <span class="stat-label">Coment.</span>
              </div>
            </div>
          </div>
          <!-- Atalhos -->
          <div class="sidebar-block sidebar-nav">
            <h6 class="sidebar-title"><i class="bi bi-compass me-1"></i> Explorar</h6>
              <button class="sidebar-nav-item" :class="{ active: !filtroStatus && !filtroTipo && !filtroModulo && !filtroMinhas && !filtroEquipe && !filtroSalvas }" @click="limparFiltros(); closeLeftDrawer()">
                <i class="bi bi-house-door me-2"></i> Todas as sugestões
              </button>
              <button class="sidebar-nav-item" :class="{ active: filtroMinhas }" @click="filtrarMinhas(); closeLeftDrawer()">
                <i class="bi bi-person me-2"></i> Minhas contribuições
                <span class="nav-count">{{ minhasStats.totalCriadas }}</span>
              </button>
              <button class="sidebar-nav-item" :class="{ active: filtroEquipe }" @click="filtrarEquipe(); closeLeftDrawer()">
                <i class="bi bi-people me-2"></i> Contribuições da Equipe
              </button>
              <button class="sidebar-nav-item" :class="{ active: filtroSalvas }" @click="filtrarSalvas(); closeLeftDrawer()">
                <i class="bi bi-bookmark-fill me-2"></i> Meus Salvos
                <span class="nav-count">{{ sugestoesSalvas.length }}</span>
              </button>
          </div>
          <!-- Feedback Recente -->
          <div class="sidebar-block sidebar-feedback">
            <h6 class="sidebar-title"><i class="bi bi-chat-square-quote me-1"></i> Feedback Recente</h6>
            <div v-if="feedbackRecente.length > 0" class="feedback-recente-list">
              <button v-for="item in feedbackRecente" :key="item.idSugestaoMelhoria" class="feedback-recente-item" @click="abrirFeedback(item); closeLeftDrawer()">
                <div class="feedback-recente-content">
                  <span class="feedback-recente-titulo">{{ item.titulo }}</span>
                  <span class="feedback-recente-preview">{{ item.feedbackAnalise }}</span>
                </div>
                <span class="badge" :class="getStatusBadge(item.lstStatusSugestao)">{{ getStatusTexto(item.lstStatusSugestao) }}</span>
              </button>
            </div>
            <div v-else class="sidebar-empty">Nenhum feedback recente</div>
          </div>
          <!-- Moderação -->
          <div v-if="authStore.isAdminInterno" class="sidebar-block widget-moderacao">
            <h6 class="sidebar-title"><i class="bi bi-shield me-1"></i> Moderação</h6>
            <div v-if="denunciasPendentesLista.length > 0" class="moderacao-list">
              <button v-for="item in denunciasPendentesLista.slice(0, 5)" :key="item.idSugestaoMelhoriaDenuncia" class="moderacao-item" @click="filtrarDenuncia(item); closeLeftDrawer()" :title="item.tituloSugestao">
                <span class="moderacao-item-motivo">{{ item.motivo }}</span>
                <span class="moderacao-item-titulo">{{ item.tituloSugestao }}</span>
              </button>
              <div v-if="denunciasPendentesLista.length > 5" class="moderacao-mais">+{{ denunciasPendentesLista.length - 5 }} mais</div>
            </div>
            <div v-else class="sidebar-empty">Nenhuma denúncia pendente</div>
          </div>
        </div>
      </aside>
    </Teleport>

    <!-- ==================== RIGHT DRAWER (MOBILE) ==================== -->
    <Teleport to="body">
      <div v-if="!isDesktop && isRightDrawerOpen" class="feed-drawer-backdrop" :style="{ zIndex: zIndexDrawer }" @click="closeRightDrawer"></div>
      <aside v-if="!isDesktop" class="feed-drawer feed-drawer-right" :class="{ 'feed-drawer-open': isRightDrawerOpen }" :style="{ zIndex: zIndexDrawer + 1 }">
        <div class="drawer-header">
          <strong class="drawer-title"><i class="bi bi-grid-3x3 me-2"></i>Widgets</strong>
          <button class="drawer-close" @click="closeRightDrawer"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="drawer-body">
          <!-- Pipeline -->
          <div class="sidebar-widget widget-pipeline">
            <h6 class="widget-title"><i class="bi bi-bar-chart me-1"></i> Pipeline de Status</h6>
            <div class="pipeline-tiles">
              <button v-for="tile in pipelineTiles" :key="tile.status" class="pipeline-tile" :class="['pipeline-tile-' + tile.key, { 'pipeline-tile-active': filtroStatus === tile.status }]" @click="filtrarPorStatus(tile.status); closeRightDrawer()">
                <span class="pipeline-tile-count">{{ tile.count }}</span>
                <span class="pipeline-tile-label"><i class="bi" :class="getStatusIcon(tile.status)"></i> {{ tile.label }}</span>
              </button>
            </div>
          </div>
          <!-- Top Votados -->
          <div class="sidebar-widget widget-top-votados">
            <h6 class="widget-title"><i class="bi bi-trophy me-1"></i> Mais Votados Pendentes</h6>
            <div v-if="topVotados.length > 0" class="top-votados-list">
              <button v-for="(item, index) in topVotados" :key="item.idSugestaoMelhoria" class="top-votado-item" @click="abrirSugestaoDesdeWidget(item); closeRightDrawer()">
                <span class="top-votado-rank" :class="'rank-' + (index + 1)">{{ index + 1 }}</span>
                <div class="top-votado-content">
                  <span class="top-votado-titulo">{{ item.titulo }}</span>
                  <span class="top-votado-meta"><i class="bi bi-folder2 me-1"></i>{{ item.modulo || 'Sem módulo' }} <span class="top-votado-votos"><i class="bi bi-hand-thumbs-up me-1"></i>{{ item.votosPositivos }}</span></span>
                </div>
              </button>
            </div>
            <div v-else class="widget-empty">Sem pendentes votados ainda</div>
          </div>
          <!-- Carousel -->
          <div class="sidebar-widget widget-carousel">
            <h6 class="widget-title"><i class="bi" :class="carouselEstagios[carouselAtivo].icone"></i> {{ carouselEstagios[carouselAtivo].titulo }}</h6>
            <div class="carousel-indicators">
              <button v-for="(estagio, idx) in carouselEstagios" :key="idx" class="carousel-dot" :class="{ active: carouselAtivo === idx }" @click="carouselAtivo = idx; reiniciarCarouselTimer()" :title="estagio.titulo"></button>
            </div>
            <div class="carousel-stage" @touchstart="onCarouselTouchStart($event)" @touchend="onCarouselTouchEnd($event)">
              <div class="carousel-track" :style="{ transform: `translateX(-${carouselAtivo * 100}%)` }">
                <div class="carousel-slide">
                  <div class="topicos-quentes-list">
                    <div v-if="topicosQuentes.length > 0">
                      <div v-for="item in topicosQuentes" :key="item.termo" class="topico-quente-item" @click="filtrarModulo(item.termo); closeRightDrawer()">
                        <div class="topico-quente-header"><span class="topico-quente-termo">{{ item.termo || 'Sem módulo' }}</span><span class="topico-quente-score">{{ item.score }}</span></div>
                        <div class="topico-quente-bar"><div class="topico-quente-bar-fill" :style="{ width: topicoQuentePercent(item) + '%' }"></div></div>
                        <div class="topico-quente-details"><span>{{ item.novasSugestoes }} novas</span><span>{{ item.novosVotos }} votos</span><span>{{ item.novosComentarios }} coment.</span></div>
                      </div>
                    </div>
                    <div v-else class="widget-empty">Nenhum tópico em ascensão</div>
                  </div>
                </div>
                <div class="carousel-slide">
                  <div class="duvidas-destaque-list">
                    <div v-if="duvidasDestaque.length > 0">
                      <button v-for="item in duvidasDestaque" :key="item.idSugestaoMelhoria" class="duvida-destaque-item" @click="abrirSugestaoDesdeWidget(item); closeRightDrawer()">
                        <div class="duvida-destaque-content"><span class="duvida-destaque-titulo">{{ item.titulo }}</span><span class="duvida-destaque-meta"><i class="bi bi-folder2 me-1"></i>{{ item.modulo || 'Sem módulo' }}</span></div>
                        <div class="duvida-destaque-stats"><span class="duvida-destaque-stat" title="Curtidas nos comentários"><i class="bi bi-heart-fill"></i> {{ item.totalCurtidasComentarios }}</span><span class="duvida-destaque-stat" title="Comentários"><i class="bi bi-chat"></i> {{ item.totalComentarios }}</span></div>
                      </button>
                    </div>
                    <div v-else class="widget-empty">Nenhuma dúvida em destaque</div>
                  </div>
                </div>
                <div class="carousel-slide">
                  <div class="hashtags-list">
                    <div v-for="item in hashtagsAscendentes" :key="item.hashtag" class="hashtag-item" @click="filtrarHashtag(item.hashtag); closeRightDrawer()">
                      <span class="hashtag-termo">#{{ item.hashtag }}</span><span class="hashtag-score">{{ item.score }}</span>
                      <div class="hashtag-bar"><div class="hashtag-bar-fill" :style="{ width: hashtagPercent(item, hashtagsAscendentes) + '%' }"></div></div>
                      <div class="hashtag-details"><span>{{ item.total }} usos</span></div>
                    </div>
                    <div v-if="hashtagsAscendentes.length === 0" class="widget-empty">Sem hashtags em ascensão</div>
                  </div>
                </div>
                <div class="carousel-slide">
                  <div class="hashtags-list">
                    <div v-for="item in hashtagsPopulares" :key="item.hashtag" class="hashtag-item" @click="filtrarHashtag(item.hashtag); closeRightDrawer()">
                      <span class="hashtag-termo">#{{ item.hashtag }}</span><span class="hashtag-count">{{ item.total }}</span>
                      <div class="hashtag-bar"><div class="hashtag-bar-fill" :style="{ width: hashtagPercent(item, hashtagsPopulares) + '%' }"></div></div>
                    </div>
                    <div v-if="hashtagsPopulares.length === 0" class="widget-empty">Sem hashtags ainda</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Radar -->
          <div class="sidebar-widget widget-radar-equipe">
            <h6 class="widget-title"><i class="bi bi-activity me-1"></i> Radar da Equipe</h6>
            <div v-if="atividadesRecentes.length > 0" class="radar-list">
              <div v-for="ativ in atividadesRecentes" :key="ativ.tsCriacao + ativ.tipo + ativ.idSugestaoMelhoria" class="radar-item" @click="abrirSugestaoDesdeWidget(ativ); closeRightDrawer()">
                <div class="radar-icon" :class="'radar-icon-' + ativ.tipo"><i class="bi" :class="ativ.tipo === 'criacao' ? 'bi-plus-circle' : 'bi-chat-dots'"></i></div>
                <div class="radar-content"><span class="radar-mensagem"><strong>{{ ativ.apelidoUsuario }}</strong> {{ ativ.mensagem }} <span class="radar-titulo">"{{ ativ.tituloSugestao }}"</span></span><span class="radar-time">{{ timeAgo(ativ.tsCriacao) }}</span></div>
              </div>
            </div>
            <div v-else class="widget-empty">Nenhuma atividade recente</div>
          </div>
        </div>
      </aside>
    </Teleport>

    <!-- ==================== TOP BAR FLUTUANTE (MOBILE) ==================== -->
    <div v-if="!isDesktop" class="feed-topbar" :class="{ 'feed-topbar-visible': isTopBarVisible }">
      <!-- Linha 1: Label + botões de ação -->
      <div class="topbar-row topbar-row-top">
        <button class="topbar-btn" @click="openLeftDrawer" title="Menu">
          <i class="bi bi-list"></i>
        </button>
        <span class="topbar-label"><i class="bi bi-lightbulb"></i> Sugestões de Melhorias e Dúvidas</span>
        <div class="topbar-actions">
          <button class="topbar-btn topbar-btn-refresh" @click="atualizarFeed" title="Rolar ao topo e atualizar">
            <i class="bi bi-arrow-clockwise"></i>
          </button>
          <button class="topbar-btn" @click="openRightDrawer" title="Widgets">
            <i class="bi bi-grid-3x3-gap"></i>
          </button>
        </div>
      </div>
      <!-- Linha 2: Filtros -->
      <div class="topbar-row topbar-row-filters">
        <select class="topbar-select" v-model="filtroStatus" @change="buscarDados(1)">
          <option value="">Status</option>
          <option v-for="(codigo, nome) in statusOptions" :key="codigo" :value="codigo">{{ nome }}</option>
        </select>
        <select class="topbar-select" v-model="filtroTipo" @change="buscarDados(1)">
          <option value="">Tipo</option>
          <option v-for="(codigo, nome) in SUGEST_TIPO" :key="codigo" :value="codigo">{{ nome }}</option>
        </select>
        <input type="text" class="topbar-search" v-model="filtroBusca" placeholder="Buscar..." @keydown.enter="buscarDados(1)" />
      </div>
    </div>

    <!-- ==================== FABS MOBILE (sempre visíveis) ==================== -->
    <div v-if="!isDesktop" class="feed-fabs" :class="{ 'feed-fabs-hidden': isTopBarVisible }">
      <button class="feed-fab feed-fab-left" @click="openLeftDrawer" title="Menu (navegação)">
        <i class="bi bi-list"></i>
      </button>
      <button class="feed-fab feed-fab-right" @click="openRightDrawer" title="Widgets (pipeline, votados, radar)">
        <i class="bi bi-grid-3x3-gap"></i>
      </button>
    </div>

    <!-- ==================== LAYOUT 3 COLUNAS ==================== -->
    <div class="feed-layout" :class="{ 'feed-layout-mobile': !isDesktop }">
      <!-- ========== COLUNA ESQUERDA: NAVEGAÇÃO SOCIAL ========== -->
      <aside class="feed-sidebar feed-sidebar-left">
        <!-- Perfil resumido -->
        <div class="sidebar-block sidebar-profile">
          <div class="profile-top-row">
            <div class="profile-avatar-ring">
              <div v-if="meuPerfil?.urlFotoPublica || meuPerfil?.urlFotoInterna" class="profile-avatar">
                <img :src="meuPerfil.urlFotoPublica || meuPerfil.urlFotoInterna" alt="Avatar" class="rounded-circle" width="48" height="48" style="object-fit: cover;" />
              </div>
              <div v-else class="profile-avatar" :style="{ backgroundColor: getAvatarColor(nomeUtilizador) }">
                {{ getAvatarInitial(nomeUtilizador) }}
              </div>
            </div>
            <BellSugestoes v-if="isDesktop" class="profile-bell" @abrir-sugestao="abrirSugestaoDesdeWidget($event)" />
          </div>
          <div class="profile-info">
            <strong class="profile-name">@{{ meuPerfil?.apelido || meuPerfil?.nome || nomeUtilizador }}</strong>
            <span v-if="isAdmin" class="badge badge-admin-interno">CTech</span>
          </div>
          <div class="profile-stats">
            <div class="profile-stat">
              <span class="stat-value">{{ minhasStats.totalCriadas }}</span>
              <span class="stat-label">Criadas</span>
            </div>
            <div class="profile-stat">
              <span class="stat-value">{{ minhasStats.totalVotos }}</span>
              <span class="stat-label">Votos</span>
            </div>
            <div class="profile-stat">
              <span class="stat-value">{{ minhasStats.totalComentarios }}</span>
              <span class="stat-label">Coment.</span>
            </div>
          </div>
        </div>

        <!-- Atalhos do feed -->
        <div class="sidebar-block sidebar-nav">
          <h6 class="sidebar-title"><i class="bi bi-compass me-1"></i> Explorar</h6>
          <button class="sidebar-nav-item" :class="{ active: !filtroStatus && !filtroTipo && !filtroModulo && !filtroMinhas && !filtroEquipe && !filtroSalvas }" @click="limparFiltros">
            <i class="bi bi-house-door me-2"></i> Todas as sugestões
          </button>
          <button class="sidebar-nav-item" :class="{ active: filtroMinhas }" @click="filtrarMinhas">
            <i class="bi bi-person me-2"></i> Minhas contribuições
            <span class="nav-count">{{ minhasStats.totalCriadas }}</span>
          </button>
          <button class="sidebar-nav-item" :class="{ active: filtroEquipe }" @click="filtrarEquipe">
            <i class="bi bi-people me-2"></i> Contribuições da Equipe
          </button>
          <button class="sidebar-nav-item" :class="{ active: filtroSalvas }" @click="filtrarSalvas">
            <i class="bi bi-bookmark-fill me-2"></i> Meus Salvos
            <span class="nav-count">{{ sugestoesSalvas.length }}</span>
          </button>
          <button class="sidebar-nav-item" @click="abrirNovaSugestao">
            <i class="bi bi-plus-circle me-2"></i> Nova ideia
          </button>
        </div>

        <!-- Feedback Recente -->
        <div class="sidebar-block sidebar-feedback">
          <h6 class="sidebar-title"><i class="bi bi-chat-square-quote me-1"></i> Feedback Recente</h6>
          <div v-if="feedbackRecente.length > 0" class="feedback-recente-list">
            <button
              v-for="item in feedbackRecente"
              :key="item.idSugestaoMelhoria"
              class="feedback-recente-item"
              @click="abrirFeedback(item)"
            >
              <div class="feedback-recente-content">
                <span class="feedback-recente-titulo">{{ item.titulo }}</span>
                <span class="feedback-recente-preview">{{ item.feedbackAnalise }}</span>
              </div>
              <span class="badge" :class="getStatusBadge(item.lstStatusSugestao)">
                {{ getStatusTexto(item.lstStatusSugestao) }}
              </span>
            </button>
          </div>
          <div v-else class="sidebar-empty">Nenhum feedback recente</div>
        </div>

        <!-- Módulos (grupos) -->
        <div class="sidebar-block sidebar-modules">
          <h6 class="sidebar-title"><i class="bi bi-folder2 me-1"></i> Módulos</h6>
          <button
            v-for="mod in modulosConteo"
            :key="mod.modulo"
            class="sidebar-module-item"
            :class="{ active: filtroModulo === mod.modulo }"
            @click="filtrarModulo(mod.modulo)"
          >
            <i class="bi bi-box me-2"></i>
            <span class="module-name">{{ mod.modulo || 'Sem módulo' }}</span>
            <span class="nav-count">{{ mod.count }}</span>
          </button>
          <div v-if="modulosConteo.length === 0" class="sidebar-empty">Sem módulos ainda</div>
        </div>

        <!-- Widget: Moderação (AdminInterno) -->
        <div v-if="authStore.isAdminInterno" class="sidebar-block widget-moderacao">
          <h6 class="sidebar-title"><i class="bi bi-shield me-1"></i> Moderação</h6>
          <div v-if="denunciasPendentesLista.length > 0" class="moderacao-list">
            <button
              v-for="item in denunciasPendentesLista.slice(0, 5)"
              :key="item.idSugestaoMelhoriaDenuncia"
              class="moderacao-item"
              @click="filtrarDenuncia(item)"
              :title="item.tituloSugestao"
            >
              <span class="moderacao-item-motivo">{{ item.motivo }}</span>
              <span class="moderacao-item-titulo">{{ item.tituloSugestao }}</span>
            </button>
            <div v-if="denunciasPendentesLista.length > 5" class="moderacao-mais">
              +{{ denunciasPendentesLista.length - 5 }} mais
            </div>
          </div>
          <div v-else class="sidebar-empty">Nenhuma denúncia pendente</div>
        </div>
      </aside>

      <!-- ========== COLUNA CENTRAL: TIMELINE ========== -->
      <main class="feed-main">
        <!-- Sentinela para IntersectionObserver (detecta rolagem do feed) -->
        <div ref="feedSentinelTop" class="feed-sentinel-top" aria-hidden="true"></div>
        <!-- Header -->
        <div class="feed-header">
          <div class="d-flex align-items-center gap-2">
            <i class="bi bi-lightbulb-fill feed-header-icon"></i>
            <h4 class="mb-0 fw-bold">Sugestões de Melhorias e Dúvidas</h4>
            <span v-if="paginacao.TotalCount > 0" class="badge badge-feed-count">{{ paginacao.TotalCount }}</span>
          </div>
        </div>

        <!-- Composer (cara de rede social) -->
        <div class="feed-composer">
          <div class="composer-avatar" :style="{ backgroundColor: getAvatarColor(nomeUtilizador) }">
            {{ getAvatarInitial(nomeUtilizador) }}
          </div>
          <button class="composer-input" @click="abrirNovaSugestao">
            O que você gostaria de melhorar?
          </button>
          <button class="btn btn-feed-primary btn-composer-send" @click="abrirNovaSugestao">
            <i class="bi bi-plus-lg me-1"></i> Nova Ideia
          </button>
        </div>

        <!-- Filtros -->
        <div class="feed-filters">
          <div class="filter-group">
            <input
              type="text"
              class="form-control form-control-sm filter-input"
              v-model="filtroBusca"
              placeholder="Buscar no conteúdo..."
              @keydown.enter="buscarDados(1)"
              style="min-width:180px;"
            />
            <select class="form-select form-select-sm filter-select" v-model="filtroStatus" @change="buscarDados(1)">
              <option value="">Todos os Status</option>
              <option v-for="(codigo, nome) in statusOptions" :key="codigo" :value="codigo">{{ nome }}</option>
            </select>
            <select class="form-select form-select-sm filter-select" v-model="filtroTipo" @change="buscarDados(1)">
              <option value="">Todos os Tipos</option>
              <option v-for="(codigo, nome) in SUGEST_TIPO" :key="codigo" :value="codigo">{{ nome }}</option>
            </select>
            <!-- Filtro de denúncias (AdminInterno) -->
            <select v-if="authStore.isAdminInterno" class="form-select form-select-sm filter-select" v-model="filtroDenuncias" @change="buscarDados(1)" style="max-width:160px;">
              <option value="">Todos</option>
              <option value="comDenuncias">🛡️ Com denúncias</option>
              <option value="banidas">🚫 Banidas</option>
            </select>
            <input type="text" class="form-control form-control-sm filter-input" v-model="filtroModulo" placeholder="Buscar módulo..." style="width:130px;" />
            <button class="btn btn-sm btn-outline-feed" @click="buscarDados(1)">
              <i class="bi bi-search"></i>
            </button>
            <button v-if="filtroBusca || filtroStatus || filtroTipo || filtroModulo || filtroMinhas || filtroEquipe || filtroHashtag || filtroDenuncias || filtroSalvas" class="btn btn-sm btn-outline-feed" @click="limparFiltros">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
          <div class="filter-order">
            <button class="btn btn-sm btn-outline-feed" :class="{ active: ordenacao === 'recentes' }" @click="ordenacao = 'recentes'; buscarDados(1)">
              <i class="bi bi-clock me-1"></i> Recentes
            </button>
            <button class="btn btn-sm btn-outline-feed" :class="{ active: ordenacao === 'votos' }" @click="ordenacao = 'votos'; buscarDados(1)">
              <i class="bi bi-hand-thumbs-up me-1"></i> Mais Votados
            </button>
          </div>
        </div>

        <!-- Chips de filtro ativo -->
        <div v-if="filtroBusca || filtroStatus || filtroTipo || filtroModulo || filtroMinhas || filtroEquipe || filtroHashtag || filtroDenuncias || filtroSalvas" class="feed-active-chips">
          <span v-if="filtroBusca" class="active-chip">
            <i class="bi bi-search me-1"></i> "{{ filtroBusca }}"
            <button class="chip-close" @click="filtroBusca = ''; buscarDados(1)"><i class="bi bi-x-lg"></i></button>
          </span>
          <span v-if="filtroStatus" class="active-chip">
            <i class="bi bi-funnel me-1"></i> {{ getStatusTexto(filtroStatus) }}
            <button class="chip-close" @click="filtroStatus = ''; buscarDados(1)"><i class="bi bi-x-lg"></i></button>
          </span>
          <span v-if="filtroTipo" class="active-chip">
            <i class="bi bi-tag me-1"></i> {{ getTipoTexto(filtroTipo) }}
            <button class="chip-close" @click="filtroTipo = ''; buscarDados(1)"><i class="bi bi-x-lg"></i></button>
          </span>
          <span v-if="filtroModulo" class="active-chip">
            <i class="bi bi-folder2 me-1"></i> {{ filtroModulo }}
            <button class="chip-close" @click="filtroModulo = ''; buscarDados(1)"><i class="bi bi-x-lg"></i></button>
          </span>
          <span v-if="filtroMinhas" class="active-chip">
            <i class="bi bi-person me-1"></i> Minhas contribuições
            <button class="chip-close" @click="filtroMinhas = false; buscarDados(1)"><i class="bi bi-x-lg"></i></button>
          </span>
          <span v-if="filtroEquipe" class="active-chip">
            <i class="bi bi-people me-1"></i> Contribuições da Equipe
            <button class="chip-close" @click="filtroEquipe = false; buscarDados(1)"><i class="bi bi-x-lg"></i></button>
          </span>
          <span v-if="filtroSalvas" class="active-chip">
            <i class="bi bi-bookmark-fill me-1"></i> Meus Salvos
            <button class="chip-close" @click="filtroSalvas = false; buscarDados(1)"><i class="bi bi-x-lg"></i></button>
          </span>
          <span v-if="filtroHashtag" class="active-chip">
            <i class="bi bi-hash me-1"></i> #{{ filtroHashtag }}
            <button class="chip-close" @click="filtroHashtag = ''; buscarDados(1)"><i class="bi bi-x-lg"></i></button>
          </span>
          <span v-if="filtroDenuncias === 'comDenuncias'" class="active-chip chip-denuncias">
            <i class="bi bi-shield-exclamation me-1"></i> Com denúncias
            <button class="chip-close" @click="filtroDenuncias = ''; buscarDados(1)"><i class="bi bi-x-lg"></i></button>
          </span>
          <span v-if="filtroDenuncias === 'banidas'" class="active-chip chip-banidas">
            <i class="bi bi-slash-circle me-1"></i> Banidas
            <button class="chip-close" @click="filtroDenuncias = ''; buscarDados(1)"><i class="bi bi-x-lg"></i></button>
          </span>
        </div>

        <!-- Loading -->
        <div v-if="isLoading" class="feed-loading">
          <div class="spinner-border text-feed-primary" role="status">
            <span class="visually-hidden">Carregando...</span>
          </div>
        </div>

        <!-- Feed de Sugestões -->
        <div v-else-if="sugestoes.length > 0" class="feed-list">
          <div
            v-for="sugestao in sugestoes"
            :key="sugestao.idSugestaoMelhoria"
            class="feed-card"
            :class="['feed-card', 'feed-card-' + getTipoKey(sugestao.lstTipoSugestao), { 'feed-card-expanded': expandedCard === sugestao.idSugestaoMelhoria }]"
            :data-card-id="sugestao.idSugestaoMelhoria"
          >
            <!-- Card Header: Avatar + Info -->
            <div class="card-user">
              <div v-if="sugestao.urlFotoUsuarioCriacao" class="user-avatar-feed">
                <img :src="sugestao.urlFotoUsuarioCriacao" alt="Avatar" class="rounded-circle" width="40" height="40" style="object-fit: cover;" />
              </div>
              <div v-else class="user-avatar-feed" :style="{ backgroundColor: getAvatarColor(sugestao.apelidoUsuarioCriacao || sugestao.nomeUsuarioCriacao || sugestao.idUsuarioCriacao) }">
                {{ getAvatarInitial(sugestao.apelidoUsuarioCriacao || sugestao.nomeUsuarioCriacao) }}
              </div>
              <div class="user-info">
                <strong class="user-name">
                  {{ sugestao.apelidoUsuarioCriacao || sugestao.nomeUsuarioCriacao || 'Usuário' }}
                  <span v-if="sugestao.adminInternoCriacao" class="badge badge-admin-interno ms-1">CTech</span>
                </strong>
                <span class="user-time">{{ timeAgo(sugestao.tsCriacao) }}</span>
              </div>
              <div class="card-badges">
                <span class="badge badge-tipo" :class="'badge-tipo-' + getTipoKey(sugestao.lstTipoSugestao)">
                  <i class="bi" :class="getTipoIcon(sugestao.lstTipoSugestao)"></i> {{ getTipoTexto(sugestao.lstTipoSugestao) }}
                </span>
                <span class="badge" :class="getPriorBadge(sugestao.lstPrioridadeSugestao)">
                  {{ getPriorTexto(sugestao.lstPrioridadeSugestao) }}
                </span>
                <!-- Badge de denúncias pendentes (AdminInterno) -->
                <span v-if="authStore.isAdminInterno && sugestao.temDenunciaPendente" class="badge badge-denuncia" title="Denúncias pendentes de moderação">
                  <i class="bi bi-shield-exclamation me-1"></i>{{ sugestao.totalDenunciasPendentes }}
                </span>
              </div>
            </div>

            <!-- Card Body: Título + Descrição -->
            <div class="card-body-feed" @click="onCardBodyClick(sugestao, $event)">
              <h5 class="card-title-feed" v-html="renderizarHashtags(sugestao.titulo)"></h5>
              <div class="card-desc-feed" :class="{ 'desc-collapsed': expandedCard !== sugestao.idSugestaoMelhoria }" v-html="renderizarDescricao(sugestao.descricao)">
              </div>
              <button v-if="sugestao.descricao && sugestao.descricao.length > 120" class="btn-expand-toggle" @click.stop="toggleExpand(sugestao.idSugestaoMelhoria)">
                {{ expandedCard === sugestao.idSugestaoMelhoria ? 'Ver menos' : 'Ver mais' }}
              </button>
            </div>

            <!-- Status Bar -->
            <div class="card-status-bar">
              <span class="badge" :class="getStatusBadge(sugestao.lstStatusSugestao)">
                <i class="bi" :class="getStatusIcon(sugestao.lstStatusSugestao)"></i> {{ getStatusTexto(sugestao.lstStatusSugestao) }}
              </span>
              <span v-if="sugestao.modulo" class="card-modulo">
                <i class="bi bi-folder2 me-1"></i>{{ sugestao.modulo }}
              </span>
            </div>

            <!-- Ações: Votar, Comentar, Admin -->
            <div class="card-actions">
              <span class="btn-action-group">
                <button class="btn-action" :class="{ 'btn-action-active': sugestao.usuarioVoto }" @click="votar(sugestao)">
                  <i class="bi" :class="sugestao.usuarioVoto ? 'bi-hand-thumbs-up-fill' : 'bi-hand-thumbs-up'"></i>
                </button>
                <button v-if="sugestao.votosPositivos > 0" class="btn-action-count" @click.stop="abrirCurtidoresSugestao(sugestao)" title="Ver quem curtiu">
                  <span>{{ sugestao.votosPositivos }}</span>
                </button>
              </span>
              <button class="btn-action" @click="toggleComentarios(sugestao)">
                <i class="bi bi-chat"></i>
                <span>{{ sugestao.totalComentarios || 0 }}</span>
              </button>
              <div class="ms-auto d-flex gap-1">
                <button class="btn-action" :class="{ 'btn-action-saved': sugestao.usuarioSalvou }" @click="toggleSalvar(sugestao)" title="Salvar">
                  <i class="bi" :class="sugestao.usuarioSalvou ? 'bi-bookmark-fill' : 'bi-bookmark'"></i>
                </button>
                <button class="btn-action btn-action-report" @click="abrirDenunciaModal(sugestao)" title="Denunciar">
                  <i class="bi bi-flag"></i>
                </button>
                <!-- Botão de moderação: ver reports (AdminInterno) -->
                <button v-if="authStore.isAdminInterno" class="btn-action btn-action-moderation" :class="{ 'has-pending': sugestao.temDenunciaPendente }" @click="abrirModalReports(sugestao)" title="Ver denúncias desta sugestão">
                  <i class="bi bi-shield-shaded"></i>
                </button>
                <button v-if="isAdmin" class="btn-action btn-action-admin" @click="abrirAdminModal(sugestao)" title="Administrar">
                  <i class="bi bi-gear"></i>
                </button>
                <button v-if="isAdmin || sugestao.idUsuarioCriacao === idUsuarioLogado" class="btn-action btn-action-admin text-danger" @click="eliminar(sugestao)" title="Eliminar">
                  <i class="bi bi-trash3"></i>
                </button>
              </div>
            </div>

            <!-- Comentários (expansível) -->
            <div v-if="comentariosAbertos === sugestao.idSugestaoMelhoria" class="card-comments">
              <div class="comments-divider"></div>
              <div class="comments-list" v-if="sugestao.comentarios && sugestao.comentarios.length > 0">
                <template v-for="comentario in sugestao.comentarios" :key="comentario.idSugestaoMelhoriaComentario">
                  <div class="comment-item" :class="{ 'comment-highlight': comentarioDestacado === comentario.idSugestaoMelhoriaComentario }" :data-comment-id="comentario.idSugestaoMelhoriaComentario">
                    <div v-if="comentario.urlFotoUsuario" class="comment-avatar">
                      <img :src="comentario.urlFotoUsuario" alt="Avatar" class="rounded-circle" width="28" height="28" style="object-fit: cover;" />
                    </div>
                    <div v-else class="comment-avatar" :style="{ backgroundColor: getAvatarColor(comentario.apelidoUsuario || comentario.nomeUsuario || comentario.idUsuario) }">
                      {{ getAvatarInitial(comentario.apelidoUsuario || comentario.nomeUsuario) }}
                    </div>
                    <div class="comment-content">
                      <div class="comment-body">
                        <div class="comment-header">
                        <strong class="comment-author">
                          {{ comentario.apelidoUsuario || comentario.nomeUsuario || 'Usuário' }}
                          <span v-if="comentario.adminInternoUsuario" class="badge badge-admin-interno ms-1">CTech</span>
                        </strong>
                        <span class="comment-time">{{ timeAgo(comentario.tsCriacao) }}</span>
                      </div>
                      <p class="comment-text" v-html="renderComentario(comentario.comentario)"></p>
                      <div class="comment-actions">
                        <span class="btn-like-group">
                          <button class="btn-like-comment" :class="{ 'liked': comentario.usuarioCurtiu }" @click="curtirComentario(sugestao, comentario)">
                            <i class="bi" :class="comentario.usuarioCurtiu ? 'bi-heart-fill' : 'bi-heart'"></i>
                          </button>
                          <button v-if="comentario.curtidas > 0" class="btn-like-count" @click.stop="abrirCurtidoresComentario(sugestao, comentario)" title="Ver quem curtiu">
                            {{ comentario.curtidas }}
                          </button>
                        </span>
                        <button class="btn-reply-comment" @click="responderComentario(sugestao, comentario)">
                          <i class="bi bi-reply me-1"></i>Responder
                        </button>
                        <button v-if="authStore.isAdminInterno || Number(comentario.idUsuario) === Number(idUsuarioLogado)" class="btn-delete-comment" @click="eliminarComentario(sugestao, comentario)" title="Excluir comentário">
                          <i class="bi bi-trash3"></i>
                        </button>
                      </div>
                      </div>
                      <!-- Input de resposta para comentário raiz (com emoji picker e @menção) -->
                      <div v-if="respondendoA?.sugestaoId === sugestao.idSugestaoMelhoria && respondendoA?.idComentarioAlvo === comentario.idSugestaoMelhoriaComentario" class="comment-reply-input-area" style="margin-top:0.4rem;">
                        <div class="comment-input-wrapper" style="flex:1;position:relative;">
                          <input
                            type="text"
                            class="form-control comment-input-field"
                            v-model="novoComentario[sugestao.idSugestaoMelhoria]"
                            placeholder="Escreva uma resposta... Use @ para mencionar"
                            @keydown.enter.prevent="onCommentKeydown(sugestao, $event)"
                            @keydown.up.prevent="onCommentArrow(sugestao, -1)"
                            @keydown.down.prevent="onCommentArrow(sugestao, 1)"
                            @input="onCommentInput(sugestao.idSugestaoMelhoria, $event)"
                          />
                          <button class="btn-emoji-picker" @click="toggleEmojiPicker(sugestao.idSugestaoMelhoria)" title="Adicionar emoji">
                            😊
                          </button>
                          <!-- @Menção Dropdown -->
                          <div v-if="showMentionDropdown && activeSugestaoId === sugestao.idSugestaoMelhoria" class="mention-dropdown">
                            <div
                              v-for="(usuario, index) in mentionSuggestions"
                              :key="usuario.idUsuario"
                              class="mention-item"
                              :class="{ 'mention-item-active': selectedMentionIndex === index }"
                              @click="selecionarMention(usuario)"
                              @mouseenter="selectedMentionIndex = index"
                            >
                              <div v-if="usuario.urlFotoPublica" class="mention-avatar">
                                <img :src="usuario.urlFotoPublica" alt="" class="rounded-circle" width="20" height="20" style="object-fit: cover;" />
                              </div>
                              <div v-else class="mention-avatar mention-avatar-placeholder rounded-circle d-flex align-items-center justify-content-center bg-secondary text-white" style="width:20px;height:20px;font-size:0.6rem;">
                                {{ (usuario.apelido || '?')[0] }}
                              </div>
                              <span>@{{ usuario.apelido }}</span>
                              <span v-if="usuario.adminInterno" class="mention-tag">CTech</span>
                            </div>
                          </div>
                          <!-- Emoji Picker Popup -->
                          <div v-if="emojiPickerOpen === sugestao.idSugestaoMelhoria" class="emoji-picker-popup">
                            <div class="emoji-grid">
                              <button
                                v-for="emoji in emojis"
                                :key="emoji"
                                class="emoji-item"
                                @click="inserirEmoji(sugestao.idSugestaoMelhoria, emoji)"
                              >{{ emoji }}</button>
                            </div>
                          </div>
                        </div>
                        <button class="btn-send-comment" @click="enviarComentario(sugestao)" :disabled="!novoComentario[sugestao.idSugestaoMelhoria]?.trim()">
                          <i class="bi bi-send-fill"></i>
                        </button>
                        <button class="btn btn-sm btn-outline-feed ms-1" @click="cancelarResposta" title="Cancelar">
                          <i class="bi bi-x"></i>
                        </button>
                      </div>
                      <!-- Botão "Ver N respostas" quando colapsado -->
                      <div v-if="comentario.totalRespostas > 0 && !respostasAbertas.has(comentario.idSugestaoMelhoriaComentario)" class="comment-replies-toggle">
                        <button class="btn-ver-respostas" @click="toggleRespostas(comentario)">
                          <i class="bi bi-chat-dots me-1"></i> Ver {{ comentario.totalRespostas }} {{ comentario.totalRespostas === 1 ? 'resposta' : 'respostas' }}
                        </button>
                      </div>

                      <!-- Respostas quando expandido -->
                      <div v-if="comentario.respostas && comentario.respostas.length > 0 && respostasAbertas.has(comentario.idSugestaoMelhoriaComentario)" class="comment-replies">
                        <div v-for="resposta in comentario.respostas" :key="resposta.idSugestaoMelhoriaComentario" class="comment-item comment-item-reply" :class="{ 'comment-highlight': comentarioDestacado === resposta.idSugestaoMelhoriaComentario }" :data-comment-id="resposta.idSugestaoMelhoriaComentario">
                          <div v-if="resposta.urlFotoUsuario" class="comment-avatar">
                            <img :src="resposta.urlFotoUsuario" alt="Avatar" class="rounded-circle" width="24" height="24" style="object-fit: cover;" />
                          </div>
                          <div v-else class="comment-avatar" :style="{ backgroundColor: getAvatarColor(resposta.apelidoUsuario || resposta.nomeUsuario || resposta.idUsuario), width:'24px', height:'24px', fontSize:'0.6rem' }">
                            {{ getAvatarInitial(resposta.apelidoUsuario || resposta.nomeUsuario) }}
                          </div>
                          <div class="comment-content">
                            <div class="comment-body">
                              <div class="comment-header">
                              <strong class="comment-author" style="font-size:0.75rem;">
                                {{ resposta.apelidoUsuario || resposta.nomeUsuario || 'Usuário' }}
                                <span v-if="resposta.adminInternoUsuario" class="badge badge-admin-interno ms-1">CTech</span>
                              </strong>
                              <span class="comment-time">{{ timeAgo(resposta.tsCriacao) }}</span>
                            </div>
                            <p class="comment-text" style="font-size:0.78rem;" v-html="renderComentario(resposta.comentario)"></p>
                            <div class="comment-actions">
                              <span class="btn-like-group">
                                <button class="btn-like-comment" :class="{ 'liked': resposta.usuarioCurtiu }" @click="curtirComentario(sugestao, resposta)">
                                  <i class="bi" :class="resposta.usuarioCurtiu ? 'bi-heart-fill' : 'bi-heart'"></i>
                                </button>
                                <button v-if="resposta.curtidas > 0" class="btn-like-count" @click.stop="abrirCurtidoresComentario(sugestao, resposta)" title="Ver quem curtiu">
                                  {{ resposta.curtidas }}
                                </button>
                              </span>
                              <button class="btn-reply-comment" @click="responderComentario(sugestao, resposta)">
                                <i class="bi bi-reply me-1"></i>Responder
                              </button>
                              <button v-if="authStore.isAdminInterno || Number(resposta.idUsuario) === Number(idUsuarioLogado)" class="btn-delete-comment" @click="eliminarComentario(sugestao, resposta)" title="Excluir resposta">
                                <i class="bi bi-trash3"></i>
                              </button>
                            </div>
                          </div>
                          <!-- Input de resposta indentado (por comentário filho) com emoji picker e @menção -->
                          <div v-if="respondendoA?.sugestaoId === sugestao.idSugestaoMelhoria && respondendoA?.idComentarioAlvo === resposta.idSugestaoMelhoriaComentario" class="comment-reply-input-area">
                            <div class="comment-input-wrapper" style="flex:1;position:relative;">
                              <input
                                type="text"
                                class="form-control comment-input-field"
                                v-model="novoComentario[sugestao.idSugestaoMelhoria]"
                                placeholder="Escreva uma resposta... Use @ para mencionar"
                                @keydown.enter.prevent="onCommentKeydown(sugestao, $event)"
                                @keydown.up.prevent="onCommentArrow(sugestao, -1)"
                                @keydown.down.prevent="onCommentArrow(sugestao, 1)"
                                @input="onCommentInput(sugestao.idSugestaoMelhoria, $event)"
                              />
                              <button class="btn-emoji-picker" @click="toggleEmojiPicker(sugestao.idSugestaoMelhoria)" title="Adicionar emoji">
                                😊
                              </button>
                              <!-- @Menção Dropdown -->
                              <div v-if="showMentionDropdown && activeSugestaoId === sugestao.idSugestaoMelhoria" class="mention-dropdown">
                                <div
                                  v-for="(usuario, index) in mentionSuggestions"
                                  :key="usuario.idUsuario"
                                  class="mention-item"
                                  :class="{ 'mention-item-active': selectedMentionIndex === index }"
                                  @click="selecionarMention(usuario)"
                                  @mouseenter="selectedMentionIndex = index"
                                >
                                  <div v-if="usuario.urlFotoPublica" class="mention-avatar">
                                    <img :src="usuario.urlFotoPublica" alt="" class="rounded-circle" width="20" height="20" style="object-fit: cover;" />
                                  </div>
                                  <div v-else class="mention-avatar mention-avatar-placeholder rounded-circle d-flex align-items-center justify-content-center bg-secondary text-white" style="width:20px;height:20px;font-size:0.6rem;">
                                    {{ (usuario.apelido || '?')[0] }}
                                  </div>
                                  <span>@{{ usuario.apelido }}</span>
                                  <span v-if="usuario.adminInterno" class="mention-tag">CTech</span>
                                </div>
                              </div>
                              <!-- Emoji Picker Popup -->
                              <div v-if="emojiPickerOpen === sugestao.idSugestaoMelhoria" class="emoji-picker-popup">
                                <div class="emoji-grid">
                                  <button
                                    v-for="emoji in emojis"
                                    :key="emoji"
                                    class="emoji-item"
                                    @click="inserirEmoji(sugestao.idSugestaoMelhoria, emoji)"
                                  >{{ emoji }}</button>
                                </div>
                              </div>
                            </div>
                            <button class="btn-send-comment" @click="enviarComentario(sugestao)" :disabled="!novoComentario[sugestao.idSugestaoMelhoria]?.trim()">
                              <i class="bi bi-send-fill"></i>
                            </button>
                            <button class="btn btn-sm btn-outline-feed ms-1" @click="cancelarResposta" title="Cancelar">
                              <i class="bi bi-x"></i>
                            </button>
                          </div>
                            </div>
                        </div>
                        <!-- Botão "Carregar mais respostas" -->
                        <button v-if="comentario.totalRespostas > comentario.respostas.length" class="btn-ver-mais-respostas" @click="carregarMaisRespostas(sugestao, comentario)">
                          <i class="bi bi-plus-circle me-1"></i> Ver mais {{ comentario.totalRespostas - comentario.respostas.length }} respostas
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <!-- Input de Comentário com Emoji Picker e @Menção -->
              <div v-if="!respondendoA || respondendoA.sugestaoId !== sugestao.idSugestaoMelhoria" class="comment-input-area">
                <div class="comment-input-wrapper">
                  <input
                    type="text"
                    class="form-control comment-input-field"
                    v-model="novoComentario[sugestao.idSugestaoMelhoria]"
                    placeholder="Escreva um comentário... Use @ para mencionar"
                    @keydown.enter.prevent="onCommentKeydown(sugestao, $event)"
                    @keydown.up.prevent="onCommentArrow(sugestao, -1)"
                    @keydown.down.prevent="onCommentArrow(sugestao, 1)"
                    @input="onCommentInput(sugestao.idSugestaoMelhoria, $event)"
                    ref="commentInputs"
                  />
                  <button class="btn-emoji-picker" @click="toggleEmojiPicker(sugestao.idSugestaoMelhoria)" title="Adicionar emoji">
                    😊
                  </button>
                  <!-- @Menção Dropdown -->
                  <div v-if="showMentionDropdown && activeSugestaoId === sugestao.idSugestaoMelhoria" class="mention-dropdown">
                    <div
                      v-for="(usuario, index) in mentionSuggestions"
                      :key="usuario.idUsuario"
                      class="mention-item"
                      :class="{ 'mention-item-active': selectedMentionIndex === index }"
                      @click="selecionarMention(usuario)"
                      @mouseenter="selectedMentionIndex = index"
                    >
                      <div v-if="usuario.urlFotoPublica" class="mention-avatar">
                        <img :src="usuario.urlFotoPublica" alt="" class="rounded-circle" width="20" height="20" style="object-fit: cover;" />
                      </div>
                      <div v-else class="mention-avatar mention-avatar-placeholder rounded-circle d-flex align-items-center justify-content-center bg-secondary text-white" style="width:20px;height:20px;font-size:0.6rem;">
                        {{ (usuario.apelido || '?')[0] }}
                      </div>
                      <span>@{{ usuario.apelido }}</span>
                      <span v-if="usuario.adminInterno" class="mention-tag">CTech</span>
                    </div>
                  </div>
                  <!-- Emoji Picker Popup -->
                  <div v-if="emojiPickerOpen === sugestao.idSugestaoMelhoria" class="emoji-picker-popup">
                    <div class="emoji-grid">
                      <button
                        v-for="emoji in emojis"
                        :key="emoji"
                        class="emoji-item"
                        @click="inserirEmoji(sugestao.idSugestaoMelhoria, emoji)"
                      >{{ emoji }}</button>
                    </div>
                  </div>
                </div>
                <button class="btn-send-comment" @click="enviarComentario(sugestao)" :disabled="!novoComentario[sugestao.idSugestaoMelhoria]?.trim()">
                  <i class="bi bi-send-fill"></i>
                </button>
              </div>
              <!-- Carregar mais comentários -->
              <div v-if="comentariosPagination[sugestao.idSugestaoMelhoria]?.hasMore" class="feed-comments-pagination">
                <button class="btn btn-outline-feed btn-load-more btn-sm" @click="carregarMaisComentarios(sugestao)" :disabled="carregandoMaisComentarios">
                  <span v-if="carregandoMaisComentarios" class="spinner-border spinner-border-sm me-2"></span>
                  <i v-else class="bi bi-arrow-down-circle me-2"></i>
                  Carregar mais comentários
                </button>
              </div>
            </div>
          </div>

          <!-- Paginação -->
          <div class="feed-pagination">
            <button
              class="btn btn-outline-feed btn-load-more"
              :disabled="isLoading || !hasMorePages"
              @click="carregarMais"
            >
              <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
              <i v-else class="bi bi-arrow-down-circle me-2"></i>
              {{ hasMorePages ? 'Carregar mais sugestões' : 'Todas as sugestões carregadas' }}
            </button>
          </div>
        </div>

        <!-- Empty State -->
        <div v-else class="feed-empty">
          <div class="empty-icon">
            <i class="bi bi-lightbulb"></i>
          </div>
          <h5>Nenhuma sugestão encontrada</h5>
          <p>Seja o primeiro a compartilhar uma ideia de melhoria!</p>
          <button class="btn btn-feed-primary" @click="abrirNovaSugestao">
            <i class="bi bi-plus-lg me-1"></i> Criar Sugestão
          </button>
        </div>
      </main>

      <!-- ========== COLUNA DIREITA: WIDGETS ========== -->
      <aside class="feed-sidebar feed-sidebar-right">
        <!-- Widget: Status Pipeline -->
        <div class="sidebar-widget widget-pipeline">
          <h6 class="widget-title"><i class="bi bi-bar-chart me-1"></i> Pipeline de Status</h6>
          <div class="pipeline-tiles">
            <button
              v-for="tile in pipelineTiles"
              :key="tile.status"
              class="pipeline-tile"
              :class="['pipeline-tile-' + tile.key, { 'pipeline-tile-active': filtroStatus === tile.status }]"
              @click="filtrarPorStatus(tile.status)"
            >
              <span class="pipeline-tile-count">{{ tile.count }}</span>
              <span class="pipeline-tile-label">
                <i class="bi" :class="getStatusIcon(tile.status)"></i> {{ tile.label }}
              </span>
            </button>
          </div>
          <div class="pipeline-bar">
            <div
              v-for="tile in pipelineTiles"
              :key="'bar-' + tile.status"
              class="pipeline-bar-segment"
              :class="'pipeline-bar-' + tile.key"
              :style="{ width: pipelinePercent(tile.count) + '%' }"
              :title="tile.label + ': ' + tile.count"
            ></div>
          </div>
          <div class="pipeline-legend">
            <span v-for="tile in pipelineTiles" :key="'leg-' + tile.status" class="pipeline-legend-item">
              <i class="bi bi-circle-fill me-1" :class="'pipeline-dot-' + tile.key"></i> {{ tile.label }} ({{ tile.count }})
            </span>
          </div>
        </div>

        <!-- Widget: Top Votados Pendentes -->
        <div class="sidebar-widget widget-top-votados">
          <h6 class="widget-title"><i class="bi bi-trophy me-1"></i> Mais Votados Pendentes</h6>
          <div v-if="topVotados.length > 0" class="top-votados-list">
            <button
              v-for="(item, index) in topVotados"
              :key="item.idSugestaoMelhoria"
              class="top-votado-item"
              @click="abrirSugestaoDesdeWidget(item)"
            >
              <span class="top-votado-rank" :class="'rank-' + (index + 1)">{{ index + 1 }}</span>
              <div class="top-votado-content">
                <span class="top-votado-titulo">{{ item.titulo }}</span>
                <span class="top-votado-meta">
                  <i class="bi bi-folder2 me-1"></i>{{ item.modulo || 'Sem módulo' }}
                  <span class="top-votado-votos"><i class="bi bi-hand-thumbs-up me-1"></i>{{ item.votosPositivos }}</span>
                </span>
              </div>
            </button>
          </div>
          <div v-else class="widget-empty">Sem pendentes votados ainda</div>
        </div>

        <!-- Widget: Carousel 4 Estágios (Fase 2) -->
        <div class="sidebar-widget widget-carousel">
          <h6 class="widget-title">
            <i class="bi" :class="carouselEstagios[carouselAtivo].icone"></i>
            {{ carouselEstagios[carouselAtivo].titulo }}
          </h6>
          <div class="carousel-indicators">
            <button v-for="(estagio, idx) in carouselEstagios" :key="idx"
              class="carousel-dot" :class="{ active: carouselAtivo === idx }"
              @click="carouselAtivo = idx; reiniciarCarouselTimer()" :title="estagio.titulo">
            </button>
          </div>
          <div class="carousel-stage" @touchstart="onCarouselTouchStart($event)" @touchend="onCarouselTouchEnd($event)">
            <div class="carousel-track" :style="{ transform: `translateX(-${carouselAtivo * 100}%)` }">
              <!-- Estágio 0: Sugestões em Ascensão -->
              <div class="carousel-slide">
                <div class="topicos-quentes-list">
                  <div v-if="topicosQuentes.length > 0">
                    <div
                      v-for="item in topicosQuentes"
                      :key="item.termo"
                      class="topico-quente-item"
                      @click="filtrarModulo(item.termo)"
                    >
                      <div class="topico-quente-header">
                        <span class="topico-quente-termo">{{ item.termo || 'Sem módulo' }}</span>
                        <span class="topico-quente-score">{{ item.score }}</span>
                      </div>
                      <div class="topico-quente-bar">
                        <div class="topico-quente-bar-fill" :style="{ width: topicoQuentePercent(item) + '%' }"></div>
                      </div>
                      <div class="topico-quente-details">
                        <span>{{ item.novasSugestoes }} novas</span>
                        <span>{{ item.novosVotos }} votos</span>
                        <span>{{ item.novosComentarios }} coment.</span>
                      </div>
                    </div>
                  </div>
                  <div v-else class="widget-empty">Nenhum tópico em ascensão</div>
                </div>
              </div>
              <!-- Estágio 1: Dúvidas em Destaque -->
              <div class="carousel-slide">
                <div class="duvidas-destaque-list">
                  <div v-if="duvidasDestaque.length > 0">
                    <button
                      v-for="item in duvidasDestaque"
                      :key="item.idSugestaoMelhoria"
                      class="duvida-destaque-item"
                      @click="abrirSugestaoDesdeWidget(item)"
                    >
                      <div class="duvida-destaque-content">
                        <span class="duvida-destaque-titulo">{{ item.titulo }}</span>
                        <span class="duvida-destaque-meta">
                          <i class="bi bi-folder2 me-1"></i>{{ item.modulo || 'Sem módulo' }}
                        </span>
                      </div>
                      <div class="duvida-destaque-stats">
                        <span class="duvida-destaque-stat" title="Curtidas nos comentários">
                          <i class="bi bi-heart-fill"></i> {{ item.totalCurtidasComentarios }}
                        </span>
                        <span class="duvida-destaque-stat" title="Comentários">
                          <i class="bi bi-chat"></i> {{ item.totalComentarios }}
                        </span>
                      </div>
                    </button>
                  </div>
                  <div v-else class="widget-empty">Nenhuma dúvida em destaque</div>
                </div>
              </div>
              <!-- Estágio 2: Hashtags em Ascensão -->
              <div class="carousel-slide">
                <div class="hashtags-list">
                  <div v-for="item in hashtagsAscendentes" :key="item.hashtag" class="hashtag-item" @click="filtrarHashtag(item.hashtag)">
                    <span class="hashtag-termo">#{{ item.hashtag }}</span>
                    <span class="hashtag-score">{{ item.score }}</span>
                    <div class="hashtag-bar"><div class="hashtag-bar-fill" :style="{ width: hashtagPercent(item, hashtagsAscendentes) + '%' }"></div></div>
                    <div class="hashtag-details"><span>{{ item.total }} usos</span></div>
                  </div>
                  <div v-if="hashtagsAscendentes.length === 0" class="widget-empty">Sem hashtags em ascensão</div>
                </div>
              </div>
              <!-- Estágio 3: Hashtags Populares -->
              <div class="carousel-slide">
                <div class="hashtags-list">
                  <div v-for="item in hashtagsPopulares" :key="item.hashtag" class="hashtag-item" @click="filtrarHashtag(item.hashtag)">
                    <span class="hashtag-termo">#{{ item.hashtag }}</span>
                    <span class="hashtag-count">{{ item.total }}</span>
                    <div class="hashtag-bar"><div class="hashtag-bar-fill" :style="{ width: hashtagPercent(item, hashtagsPopulares) + '%' }"></div></div>
                  </div>
                  <div v-if="hashtagsPopulares.length === 0" class="widget-empty">Sem hashtags ainda</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Widget: Radar da Equipe (Fase 2) -->
        <div class="sidebar-widget widget-radar-equipe">
          <h6 class="widget-title"><i class="bi bi-activity me-1"></i> Radar da Equipe</h6>
          <div v-if="atividadesRecentes.length > 0" class="radar-list">
            <div
              v-for="ativ in atividadesRecentes"
              :key="ativ.tsCriacao + ativ.tipo + ativ.idSugestaoMelhoria"
              class="radar-item"
              @click="abrirSugestaoDesdeWidget(ativ)"
            >
              <div class="radar-icon" :class="'radar-icon-' + ativ.tipo">
                <i class="bi" :class="ativ.tipo === 'criacao' ? 'bi-plus-circle' : 'bi-chat-dots'"></i>
              </div>
              <div class="radar-content">
                <span class="radar-mensagem">
                  <strong>{{ ativ.apelidoUsuario }}</strong> {{ ativ.mensagem }}
                  <span class="radar-titulo">"{{ ativ.tituloSugestao }}"</span>
                </span>
                <span class="radar-time">{{ timeAgo(ativ.tsCriacao) }}</span>
              </div>
            </div>
          </div>
          <div v-else class="widget-empty">Nenhuma atividade recente</div>
        </div>
      </aside>
    </div>

    <!-- Modal Chat IA -->
    <SugestaoMelhoriaChatModal
      v-model="showChatModal"
      :contexto="contextoAtual"
      @sugestoes-salvas="onSugestoesSalvas"
    />

    <!-- Modal Administrar (admin) -->
    <ModalFormularioV2
      v-model="showAdminModal"
      titulo="Administrar Sugestão"
      :loading="isSavingAdmin"
      colorHeader="#8B5CF6"
      tamano="sm"
      @confirmar="salvarAdmin"
    >
      <div v-if="sugestaoAdminSelecionada" class="admin-form">
        <div class="mb-3">
          <label class="form-label fw-bold">{{ sugestaoAdminSelecionada.titulo }}</label>
        </div>
        <div class="mb-3">
          <label class="form-label">Status</label>
          <select class="form-select" v-model="editStatus">
            <option v-for="(codigo, nome) in SUGEST_STATUS" :key="codigo" :value="codigo">{{ nome }}</option>
          </select>
        </div>
        <div class="mb-3">
          <label class="form-label">Prioridade</label>
          <select class="form-select" v-model="editPrioridade">
            <option v-for="(codigo, nome) in SUGEST_PRIOR" :key="codigo" :value="codigo">{{ nome }}</option>
          </select>
        </div>
        <div class="mb-3">
          <label class="form-label">Feedback da Análise</label>
          <textarea class="form-control" v-model="editFeedback" rows="4" placeholder="Descreva a análise, decisão ou observação..."></textarea>
        </div>
      </div>
    </ModalFormularioV2>

    <!-- Modal Feedback (para usuário ver) -->
    <ModalFormularioV2
      v-model="showFeedbackModal"
      :titulo="'Feedback da Equipe'"
      colorHeader="#8B5CF6"
      tamano="sm"
      @confirmar="showFeedbackModal = false"
    >
      <div v-if="sugestaoFeedback" class="feedback-modal-content">
        <div class="feedback-sugestao-titulo mb-3">
          <strong>{{ sugestaoFeedback.titulo }}</strong>
        </div>
        <div class="mb-2">
          <span class="badge" :class="getStatusBadge(sugestaoFeedback.lstStatusSugestao)">
            {{ getStatusTexto(sugestaoFeedback.lstStatusSugestao) }}
          </span>
        </div>
        <p class="feedback-text">{{ sugestaoFeedback.feedbackAnalise }}</p>
      </div>
    </ModalFormularioV2>

    <!-- Popup Quem Curtiu -->
    <Teleport to="body">
      <div v-if="showCurtidoresModal" class="curtidores-backdrop" :style="{ zIndex: zIndexCurtidores }" @click="fecharCurtidoresPopup">
        <div class="curtidores-popup" :style="{ zIndex: zIndexCurtidores + 1 }" @click.stop>
          <div class="curtidores-popup-header">
            <strong>{{ curtidoresModalTitulo }}</strong>
            <button class="curtidores-popup-close" @click="showCurtidoresModal = false">&times;</button>
          </div>
          <div class="curtidores-popup-body">
            <div v-if="curtidoresLoading" class="curtidores-popup-loading">
              <div class="spinner-border spinner-border-sm text-feed-primary"></div>
            </div>
            <div v-else-if="curtidoresLista.length === 0" class="curtidores-popup-empty">
              Nenhuma curtida ainda
            </div>
            <div v-else class="curtidores-popup-list">
              <div v-for="curtidor in curtidoresLista" :key="curtidor.idUsuario" class="curtidor-popup-item">
                <div v-if="curtidor.urlFoto" class="curtidor-popup-avatar">
                  <img :src="curtidor.urlFoto" alt="" class="rounded-circle" width="28" height="28" style="object-fit: cover;" />
                </div>
                <div v-else class="curtidor-popup-avatar curtidor-popup-avatar-placeholder" :style="{ backgroundColor: getAvatarColor(curtidor.apelido || curtidor.nome) }">
                  {{ getAvatarInitial(curtidor.apelido || curtidor.nome) }}
                </div>
                <span class="curtidor-popup-nome">{{ curtidor.apelido || curtidor.nome }}</span>
                <span v-if="curtidor.adminInterno" class="badge badge-admin-interno ms-auto">CTech</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- Modal Denúncia (Fase 3) -->
    <ModalFormularioV2 v-model="showDenunciaModal" titulo="Denunciar Sugestão" tamano="sm" colorHeader="#EF4444" @confirmar="enviarDenuncia">
      <div class="denuncia-form">
        <div class="mb-3">
          <label class="form-label">Motivo</label>
          <select class="form-select" v-model="denunciaMotivo">
            <option value="">Selecione...</option>
            <option value="ofensivo">Conteúdo ofensivo</option>
            <option value="spam">Spam</option>
            <option value="duplicado">Duplicado</option>
            <option value="inapropriado">Conteúdo inapropriado</option>
            <option value="outro">Outro</option>
          </select>
        </div>
        <div class="mb-3">
          <label class="form-label">Descrição</label>
          <textarea class="form-control" v-model="denunciaDescricao" rows="3" placeholder="Descreva o problema..."></textarea>
        </div>
      </div>
    </ModalFormularioV2>

    <!-- Modal de Reports (AdminInterno) -->
    <ModalFormularioV2 v-if="authStore.isAdminInterno" v-model="showReportsModal" titulo="Moderação — Denúncias da Sugestão" tamanho="xl" corHeader="#EF4444" :loading="reportsSaving">
      <div class="reports-modal-body">
        <!-- Loading -->
        <div v-if="reportsLoading" class="text-center py-4">
          <div class="spinner-border text-feed-primary" role="status"></div>
        </div>

        <template v-else>
          <!-- Cabeçalho: título da sugestão -->
          <div class="reports-header">
            <strong>Sugestão:</strong>
            <span>{{ reportsSugestaoAlvo?.titulo || '-' }}</span>
          </div>

          <!-- Ações em massa (apenas pendentes) -->
          <div v-if="denunciasPendentesVisiveis.length > 0" class="reports-bulk-actions">
            <label class="d-flex align-items-center gap-2">
              <input type="checkbox" :checked="reportsSelecionados.length === denunciasPendentesVisiveis.length" @change="toggleAllReports" />
              <span>Selecionar todos ({{ denunciasPendentesVisiveis.length }})</span>
            </label>
            <span v-if="reportsSelecionados.length > 0" class="text-muted small">
              {{ reportsSelecionados.length }} selecionada(s)
            </span>
          </div>

          <!-- Lista de denúncias PENDENTES -->
          <div v-if="denunciasPendentesVisiveis.length === 0 && denunciasTratadasVisiveis.length === 0" class="text-center py-3 text-muted">
            Nenhuma denúncia encontrada para esta sugestão.
          </div>
          <div v-else-if="denunciasPendentesVisiveis.length === 0" class="mb-2 text-center text-muted small">
            Todas as denúncias foram tratadas.
          </div>
          <div v-else class="reports-list">
            <div v-for="den in denunciasPendentesVisiveis" :key="den.idSugestaoMelhoriaDenuncia" class="report-item report-item-pendente">
              <div class="report-check">
                <input type="checkbox" :checked="reportsSelecionados.includes(den.idSugestaoMelhoriaDenuncia)" @change="toggleReportSelection(den.idSugestaoMelhoriaDenuncia)" />
              </div>
              <div class="report-content">
                <div class="report-header">
                  <span class="report-motivo"><strong>{{ den.motivo }}</strong></span>
                  <span class="badge" :class="getStatusDenunciaBadge(den.lstStatusDenuncia)">{{ den.lstStatusDenuncia }}</span>
                </div>
                <div class="report-descricao" v-if="den.descricao">
                  <i class="bi bi-chat-quote me-1"></i>{{ den.descricao }}
                </div>
                <div class="report-denunciante">
                  <i class="bi bi-person me-1"></i>{{ den.nomeDenunciante || 'Anônimo' }}
                  <span v-if="den.emailDenunciante" class="text-muted ms-2">[{{ den.emailDenunciante }}]</span>
                </div>
                <div class="report-data">
                  <i class="bi bi-clock me-1"></i>{{ formatarDataBR(den.tsCriacao) }}
                </div>
                <div v-if="den.observacaoModeracao" class="report-observacao">
                  <i class="bi bi-shield me-1"></i><em>{{ den.observacaoModeracao }}</em>
                </div>
              </div>
            </div>
          </div>

          <!-- Área de Tratamento -->
          <div class="reports-treatment" v-if="denunciasPendentesVisiveis.length > 0">
            <h6 class="treatment-title"><i class="bi bi-send me-1"></i> Tratamento por E-mail</h6>
            <div class="treatment-status-row mb-2">
              <label class="treatment-label">Novo status:</label>
              <select class="form-select form-select-sm" v-model="reportsStatusTratamento" style="max-width:180px;">
                <option value="RESOLVIDA">✅ Resolvida</option>
                <option value="REJEITADA">❌ Rejeitada</option>
              </select>
            </div>
            <div class="mb-2">
              <textarea class="form-control" v-model="reportsMensagemTratamento" rows="3" placeholder="Escreva a mensagem de tratamento — ela será enviada por e-mail ao(s) denunciante(s)..."></textarea>
            </div>
            <div class="treatment-info text-muted small">
              <i class="bi bi-info-circle me-1"></i>
              A mensagem é sempre enviada por e-mail e fica registrada em <em>Observação de Moderação</em>. O status só é alterado após o envio do e-mail.
            </div>
          </div>

          <!-- Lista de denúncias TRATADAS (abaixo da caixa de e-mail) -->
          <div v-if="denunciasTratadasVisiveis.length > 0" class="reports-treated">
            <h6 class="treatment-title"><i class="bi bi-check2-circle me-1"></i> Denúncias Tratadas</h6>
            <div class="reports-list">
              <div v-for="den in denunciasTratadasVisiveis" :key="den.idSugestaoMelhoriaDenuncia" class="report-item report-item-treated">
                <div class="report-check">
                  <span class="report-done-icon"><i class="bi bi-check-lg"></i></span>
                </div>
                <div class="report-content">
                  <div class="report-header">
                    <span class="report-motivo"><strong>{{ den.motivo }}</strong></span>
                    <span class="badge" :class="getStatusDenunciaBadge(den.lstStatusDenuncia)">{{ den.lstStatusDenuncia }}</span>
                  </div>
                  <div class="report-descricao" v-if="den.descricao">
                    <i class="bi bi-chat-quote me-1"></i>{{ den.descricao }}
                  </div>
                  <div class="report-denunciante">
                    <i class="bi bi-person me-1"></i>{{ den.nomeDenunciante || 'Anônimo' }}
                    <span v-if="den.emailDenunciante" class="text-muted ms-2">[{{ den.emailDenunciante }}]</span>
                  </div>
                  <div class="report-data">
                    <i class="bi bi-clock me-1"></i>{{ formatarDataBR(den.tsCriacao) }}
                  </div>
                  <div v-if="den.observacaoModeracao" class="report-observacao">
                    <i class="bi bi-shield me-1"></i><em>{{ den.observacaoModeracao }}</em>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>

      <!-- Footer customizado -->
      <template #footer>
        <div class="d-flex gap-2 w-100 justify-content-end">
          <button type="button" class="btn btn-outline-secondary" @click="showReportsModal = false" :disabled="reportsSaving">
            Cancelar
          </button>
          <button type="button" class="btn btn-danger text-white fw-bold" @click="tratarDenuncias" :disabled="reportsSaving || reportsSelecionados.length === 0 || !reportsMensagemTratamento.trim()">
            <span v-if="reportsSaving" class="spinner-border spinner-border-sm me-1"></span>
            <i class="bi bi-send me-1"></i>Tratar e Enviar E-mail
          </button>
        </div>
      </template>
    </ModalFormularioV2>

    <!-- Modal de Confirmação -->
    <ConfirmationModal
      ref="confirmModalRef"
      :title="confirmTitle"
      :message="confirmMessage"
      confirmButtonText="Sim, excluir"
      cancelButtonText="Cancelar"
      @confirmed="onConfirmResult"
    />
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, onUnmounted, nextTick } from 'vue'
import api from '@/services/api'
import { reservarZIndex, liberarZIndex, BASE_ZINDEX } from '@/composables/useZIndex'
import { renderizarMarkdown } from '@/utils/markdownSeguro'
import { useAuthStore } from '@/stores/auth'
import { usePendenciasStore } from '@/stores/pendencias'
import SugestaoMelhoriaChatModal from './SugestaoMelhoriaChatModal.vue'
import BellSugestoes from './BellSugestoes.vue'
import ModalFormularioV2 from '@/components/base/modal/ModalFormularioV2.vue'
import ConfirmationModal from '@/components/base/modal/ConfirmationModal.vue'
import { SUGEST_TIPO } from '@/constants/SUGEST_TIPO'
import { SUGEST_PRIOR } from '@/constants/SUGEST_PRIOR'
import { SUGEST_STATUS } from '@/constants/SUGEST_STATUS'

const emit = defineEmits(['show-notification'])

const authStore = useAuthStore()

// ==================== RESPONSIVO (detecção local) ====================
const isDesktop = ref(window.innerWidth >= 992)
const isLeftDrawerOpen = ref(false)
const isRightDrawerOpen = ref(false)
const isTopBarVisible = ref(false)

// --- Empilhamento (z-index) via registry central ---
const zIndexDrawer = ref(BASE_ZINDEX)
const tokenDrawer = ref(null)
const drawerAberto = computed(() => isLeftDrawerOpen.value || isRightDrawerOpen.value)

watch(drawerAberto, (aberto) => {
  if (aberto) {
    const { token, zIndex: z } = reservarZIndex()
    tokenDrawer.value = token
    zIndexDrawer.value = z
  } else {
    liberarZIndex(tokenDrawer.value)
    tokenDrawer.value = null
  }
})
const headerOffset = ref(56)
const feedSentinelTop = ref(null)
let topObserver = null
let touchStartX = 0
let touchStartY = 0

const handleResize = () => {
  isDesktop.value = window.innerWidth >= 992
  const headerEl = document.querySelector('.admin-header-global')
  headerOffset.value = headerEl ? headerEl.offsetHeight : 56
  document.documentElement.style.setProperty('--feed-header-h', headerOffset.value + 'px')
}

const openLeftDrawer = () => { isLeftDrawerOpen.value = true }
const closeLeftDrawer = () => { isLeftDrawerOpen.value = false }
const openRightDrawer = () => { isRightDrawerOpen.value = true }
const closeRightDrawer = () => { isRightDrawerOpen.value = false }

const onTouchStart = (e) => {
  touchStartX = e.touches[0].clientX
  touchStartY = e.touches[0].clientY
}

const onTouchEnd = (e) => {
  if (isDesktop.value) return
  const diffX = e.changedTouches[0].clientX - touchStartX
  const diffY = e.changedTouches[0].clientY - touchStartY
  if (Math.abs(diffY) > Math.abs(diffX) * 2) return
  if (diffX > 80) openLeftDrawer()
  if (diffX < -80) openRightDrawer()
}

// IntersectionObserver: detecta quando o sentinela do topo do feed sai da viewport.
// NÃO depende de qual container rola (window, .list-container, etc.).
const setupScrollObserver = () => {
  if (!feedSentinelTop.value || isDesktop.value) return
  topObserver = new IntersectionObserver((entries) => {
    const entry = entries[0]
    // Sentinela fora de vista => usuário rolou o feed => mostra top bar
    // Sentinela visível => usuário no topo => esconde top bar
    isTopBarVisible.value = !entry.isIntersecting
  }, { threshold: 0 })
  topObserver.observe(feedSentinelTop.value)
}

const destroyScrollObserver = () => {
  if (topObserver) {
    topObserver.disconnect()
    topObserver = null
  }
}

// ==================== ESTADOS ====================
const sugestoes = ref([])
const sugestoesSalvas = ref([])
const isLoading = ref(false)
const isSavingAdmin = ref(false)
const showChatModal = ref(false)
const showAdminModal = ref(false)
const showFeedbackModal = ref(false)
const contextoAtual = ref({})
const expandedCard = ref(null)
const comentariosAbertos = ref(null)
const emojiPickerOpen = ref(null)
const novoComentario = reactive({})
const sugestaoAdminSelecionada = ref(null)
const sugestaoFeedback = ref(null)
const meuPerfil = ref(null)

// ==================== DENÚNCIAS (FASE 3) ====================
const showDenunciaModal = ref(false)
const denunciaMotivo = ref('')
const denunciaDescricao = ref('')
const denunciaSugestaoAlvo = ref(null)
const denunciasPendentes = ref(0)
const denunciasPendentesLista = ref([])

// ==================== MODAL DE REPORTS (AdminInterno) ====================
const showReportsModal = ref(false)
const reportsSugestaoAlvo = ref(null)
const reportsDenuncias = ref([]) // todas as denúncias carregadas da API
const reportsDenunciasTratadas = ref([]) // denúncias tratadas na sessão atual
const reportsLoading = ref(false)
const reportsStatusTratamento = ref('RESOLVIDA')
const reportsMensagemTratamento = ref('')
const reportsSelecionados = ref([])
const reportsSaving = ref(false)

// Computeds que separam pendentes e tratadas
const denunciasPendentesVisiveis = computed(() =>
  reportsDenuncias.value.filter(d => d.lstStatusDenuncia === 'PENDENTE')
)
const denunciasTratadasVisiveis = computed(() => [
  ...reportsDenuncias.value.filter(d => d.lstStatusDenuncia !== 'PENDENTE'),
  ...reportsDenunciasTratadas.value
])

// ==================== MODAL DE CONFIRMAÇÃO ====================
const confirmModalRef = ref(null)
const confirmTitle = ref('Confirmação')
const confirmMessage = ref('')
let confirmCallback = null

const mostrarConfirmacao = (title, message, callback) => {
  confirmTitle.value = title
  confirmMessage.value = message
  confirmCallback = callback
  confirmModalRef.value?.show()
}

const onConfirmResult = (result) => {
  if (result && confirmCallback) {
    confirmCallback()
    confirmCallback = null
  }
}

const abrirDenunciaModal = (sugestao) => {
  denunciaSugestaoAlvo.value = sugestao
  denunciaMotivo.value = ''
  denunciaDescricao.value = ''
  showDenunciaModal.value = true
}

const enviarDenuncia = async () => {
  if (!denunciaMotivo.value) {
    emit('show-notification', { type: 'warning', message: 'Selecione um motivo.' })
    return
  }
  try {
    await api.post(`/SugestoesMelhoria/${denunciaSugestaoAlvo.value.idSugestaoMelhoria}/denunciar`, {
      motivo: denunciaMotivo.value,
      descricao: denunciaDescricao.value
    })
    emit('show-notification', { type: 'success', message: 'Denúncia registrada. A equipe irá analisar.' })
    showDenunciaModal.value = false
  } catch (error) {
    const msg = error.response?.data?.message || 'Erro ao denunciar.'
    emit('show-notification', { type: 'error', message: msg })
  }
}

const carregarDenunciasPendentes = async () => {
  if (!authStore.isAdminInterno) return
  try {
    const response = await api.get('/SugestoesMelhoria/denuncias/pendentes', {
      _suppressLoading: true
    })
    denunciasPendentesLista.value = response.data || []
    denunciasPendentes.value = denunciasPendentesLista.value.length
  } catch { denunciasPendentes.value = 0; denunciasPendentesLista.value = [] }
}

const filtrarDenuncia = (item) => {
  // Ativa o filtro de denúncias e busca
  filtroDenuncias.value = 'comDenuncias'
  filtroBusca.value = ''
  filtroStatus.value = ''
  filtroTipo.value = ''
  filtroModulo.value = ''
  filtroMinhas.value = false
  filtroEquipe.value = false
  filtroHashtag.value = ''
  buscarDados(1)
  // Tenta abrir o modal de reports diretamente (se a sugestão estiver carregada)
  const sugestao = sugestoes.value.find(s => s.idSugestaoMelhoria === item.idSugestaoMelhoria)
  if (sugestao) {
    abrirModalReports(sugestao)
  }
}

const abrirModalReports = async (sugestao) => {
  reportsSugestaoAlvo.value = sugestao
  reportsDenuncias.value = []
  reportsDenunciasTratadas.value = []
  reportsSelecionados.value = []
  reportsMensagemTratamento.value = ''
  reportsStatusTratamento.value = 'RESOLVIDA'
  reportsLoading.value = true
  showReportsModal.value = true
  try {
    const response = await api.get(`/SugestoesMelhoria/${sugestao.idSugestaoMelhoria}/denuncias`)
    reportsDenuncias.value = response.data || []
  } catch {
    reportsDenuncias.value = []
  } finally {
    reportsLoading.value = false
  }
}

const toggleReportSelection = (idDenuncia) => {
  const idx = reportsSelecionados.value.indexOf(idDenuncia)
  if (idx >= 0) {
    reportsSelecionados.value.splice(idx, 1)
  } else {
    reportsSelecionados.value.push(idDenuncia)
  }
}

const toggleAllReports = () => {
  const pendentes = denunciasPendentesVisiveis.value
  if (reportsSelecionados.value.length === pendentes.length) {
    reportsSelecionados.value = []
  } else {
    reportsSelecionados.value = pendentes.map(d => d.idSugestaoMelhoriaDenuncia)
  }
}

const tratarDenuncias = async () => {
  if (reportsSelecionados.value.length === 0) {
    emit('show-notification', { type: 'warning', message: 'Selecione ao menos uma denúncia para tratar.' })
    return
  }
  if (!reportsMensagemTratamento.value.trim()) {
    emit('show-notification', { type: 'warning', message: 'Escreva a mensagem de tratamento para enviar por e-mail.' })
    return
  }
  reportsSaving.value = true
  try {
    const status = reportsStatusTratamento.value
    const mensagem = reportsMensagemTratamento.value.trim()
    await api.put('/SugestoesMelhoria/denuncias/resolver-lote', {
      idsDenuncias: reportsSelecionados.value,
      status,
      observacao: mensagem,
      mensagemTratamento: mensagem,
      enviarEmail: true,
      enviarParaTodos: false
    })
    // Move as denúncias selecionadas para a lista de tratadas (atualiza localmente)
    const idsTratados = new Set(reportsSelecionados.value)
    reportsDenuncias.value = reportsDenuncias.value.map(d =>
      idsTratados.has(d.idSugestaoMelhoriaDenuncia)
        ? { ...d, lstStatusDenuncia: status, observacaoModeracao: mensagem }
        : d
    )
    reportsSelecionados.value = []
    emit('show-notification', { type: 'success', message: `${idsTratados.size} denúncia(s) tratada(s) como "${status}".` })
    usePendenciasStore().atualizarContagem()
    // Recarrega o widget (não recarrega cards — já foi atualizado localmente)
    carregarDenunciasPendentes()
  } catch (error) {
    const msg = error.response?.data?.message || 'Erro ao tratar denúncias.'
    emit('show-notification', { type: 'error', message: msg })
  } finally {
    reportsSaving.value = false
  }
}

const getStatusDenunciaBadge = (status) => {
  if (status === 'PENDENTE') return 'bg-warning text-dark'
  if (status === 'RESOLVIDA') return 'bg-success'
  if (status === 'REJEITADA') return 'bg-secondary'
  return 'bg-light text-dark'
}

const editStatus = ref('')
const editPrioridade = ref('')
const editFeedback = ref('')

const isAdmin = computed(() => authStore.isAdminInterno || authStore.isAdminCliente)
const nomeUtilizador = computed(() => authStore.nomeUtilizador)
const idUsuarioLogado = computed(() => authStore.utilizador?.id)

// Remove Banido e Rascunho das opções do filtro de status (são geridos apenas pelo filtro de denúncias)
// Usa ref + filter para evitar criar novo objeto a cada render (causa loop infinito)
const statusOptions = ref(
  Object.fromEntries(
    Object.entries(SUGEST_STATUS).filter(([key]) => key !== 'Banido' && key !== 'Rascunho')
  )
)

const filtroBusca = ref('')
const filtroStatus = ref('')
const filtroTipo = ref('')
const filtroModulo = ref('')
const filtroMinhas = ref(false)
const filtroEquipe = ref(false)
const filtroHashtag = ref('')
const filtroDenuncias = ref('') // '', 'comDenuncias' — apenas AdminInterno
const filtroSalvas = ref(false)
const ordenacao = ref('recentes')

const paginacao = reactive({
  TotalCount: 0,
  PageSize: 10,
  CurrentPage: 1
})

const hasMorePages = computed(() => {
  return paginacao.CurrentPage * paginacao.PageSize < paginacao.TotalCount
})

// ==================== WIDGETS: PIPELINE ====================
const resumoStatus = ref([])

const pipelineTiles = computed(() => {
  const ordem = [
    { status: SUGEST_STATUS.Pendente, key: 'pendente', label: 'Pendente' },
    { status: SUGEST_STATUS.EmAnalise, key: 'analise', label: 'Em Análise' },
    { status: SUGEST_STATUS.Planejado, key: 'planejado', label: 'Planejado' },
    { status: SUGEST_STATUS.EmDesenvolvimento, key: 'desenvolvimento', label: 'Em Desenvolvimento' },
    { status: SUGEST_STATUS.Concluido, key: 'concluido', label: 'Concluído' },
    { status: SUGEST_STATUS.Rejeitado, key: 'rejeitado', label: 'Rejeitado' }
  ]
  return ordem.map(t => {
    const found = resumoStatus.value.find(r => r.status === t.status)
    return { ...t, count: found ? found.count : 0 }
  })
})

const pipelineTotal = computed(() => pipelineTiles.value.reduce((acc, t) => acc + t.count, 0))

const pipelinePercent = (count) => {
  if (pipelineTotal.value === 0) return 0
  return Math.round((count / pipelineTotal.value) * 100)
}

const carregarResumoStatus = async () => {
  try {
    const response = await api.get('/SugestoesMelhoria/resumo-status', {
      _suppressLoading: true
    })
    resumoStatus.value = response.data || []
  } catch (error) {
    console.error('Erro ao carregar resumo de status:', error)
    resumoStatus.value = []
  }
}

const filtrarPorStatus = (status) => {
  filtroStatus.value = filtroStatus.value === status ? '' : status
  buscarDados(1)
}

// ==================== WIDGETS: TOP VOTADOS PENDENTES ====================
const topVotados = ref([])

const carregarTopVotados = async () => {
  try {
    const response = await api.get('/SugestoesMelhoria', {
      params: {
        status: SUGEST_STATUS.Pendente,
        sortBy: 'votos',
        page: 1,
        pageSize: 5
      },
      _suppressLoading: true
    })
    topVotados.value = response.data || []
  } catch (error) {
    console.error('Erro ao carregar top votados:', error)
    topVotados.value = []
  }
}

const comentarioDestacado = ref(null)
let highlightTimer = null
let destacadoClearTimer = null

// Watch que manipula o DOM diretamente para garantir que o highlight apareça
watch(comentarioDestacado, (novoId) => {
  // Cancela TODOS os timers anteriores (evita conflito com cliques rápidos)
  if (highlightTimer) {
    clearTimeout(highlightTimer)
    highlightTimer = null
  }
  if (destacadoClearTimer) {
    clearTimeout(destacadoClearTimer)
    destacadoClearTimer = null
  }

  // Remove highlight de todos os comentários (zera transições primeiro)
  document.querySelectorAll('[data-comment-id]').forEach(el => {
    const body = el.querySelector('.comment-body')
    if (body) {
      body.style.transition = 'none'
      body.style.borderColor = ''
      body.style.background = ''
    }
  })

  // Aplica highlight no comentário alvo com animação suave
  if (novoId) {
    const el = document.querySelector(`[data-comment-id="${novoId}"]`)
    if (el) {
      const body = el.querySelector('.comment-body')
      if (!body) return

      // Força o browser a processar a limpeza antes de aplicar a nova transição
      // Isso evita que uma transição de fade-out anterior contamine o novo fade-in
      body.getBoundingClientRect() // reflow forçado

      // Aparece com transição suave
      body.style.transition = 'border-color 0.4s ease-in, background 0.4s ease-in'
      body.style.borderColor = '#8B5CF6'
      body.style.background = 'rgba(139, 92, 246, 0.08)'

      // Após 2.5s exibindo, inicia o fade out suave
      highlightTimer = setTimeout(() => {
        body.style.transition = 'border-color 1s ease-out, background 1s ease-out'
        body.style.borderColor = 'transparent'
        body.style.background = 'transparent'
        // Após a transição (1s), limpa os estilos completamente
        const fadeTimer = setTimeout(() => {
          body.style.transition = 'none'
          body.style.borderColor = ''
          body.style.background = ''
        }, 1000)
        // Guarda referência para limpar se novo clique chegar
        highlightTimer = fadeTimer
      }, 2500)
    }
  }
})

const abrirSugestaoDesdeWidget = async (payload) => {
  closeLeftDrawer()
  const idSugestao = typeof payload === 'number' ? payload : payload?.idSugestaoMelhoria
  const idComentario = payload?.idComentario
  if (!idSugestao) return

  // Se tem idComentario, descobre em qual página ele está e qual o rootCommentId
  let paginaAlvo = 1
  let rootCommentId = null
  if (idComentario) {
    try {
      const resp = await api.get(`/SugestoesMelhoria/${idSugestao}/comentarios/${idComentario}/pagina`)
      paginaAlvo = resp.data.page
      rootCommentId = resp.data.rootCommentId
    } catch {
      // fallback: página 1
    }
  }

  const naTimeline = sugestoes.value.find(s => s.idSugestaoMelhoria === idSugestao)
  if (naTimeline) {
    expandedCard.value = idSugestao
    comentariosAbertos.value = idSugestao
    // Carrega comentários na página correta (sempre recarrega se tem idComentario)
    if (idComentario || !naTimeline.comentarios || naTimeline.comentarios.length === 0) {
      await carregarComentarios(naTimeline, paginaAlvo)
    } else if (paginaAlvo > 1) {
      await carregarComentarios(naTimeline, paginaAlvo)
    }

    // Se o comentário alvo é uma resposta, expande as respostas do pai
    if (idComentario && rootCommentId) {
      const rootComment = naTimeline.comentarios.find(c => c.idSugestaoMelhoriaComentario === rootCommentId)
      if (rootComment) {
        respostasAbertas.add(rootCommentId)
        const temResposta = rootComment.respostas?.some(r => r.idSugestaoMelhoriaComentario === idComentario)
        if (!temResposta && rootComment.totalRespostas > (rootComment.respostas?.length || 0)) {
          await carregarMaisRespostas(naTimeline, rootComment)
        }
      }
    }

    // Destaca o comentário mencionado
    if (idComentario) {
      comentarioDestacado.value = null
      await nextTick()
      comentarioDestacado.value = idComentario
      if (destacadoClearTimer) clearTimeout(destacadoClearTimer)
      destacadoClearTimer = setTimeout(() => {
        comentarioDestacado.value = null
        destacadoClearTimer = null
      }, 3500)
    }
    nextTick(() => {
      const card = document.querySelector(`[data-card-id="${idSugestao}"]`)
      if (card) card.scrollIntoView({ behavior: 'smooth', block: 'center' })
      // Scrolla a área de comentários para mostrar o comentário destacado
      if (idComentario) {
        const commentEl = document.querySelector(`[data-comment-id="${idComentario}"]`)
        if (commentEl) {
          const commentsList = commentEl.closest('.comments-list')
          if (commentsList) {
            commentEl.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }
      }
    })
  } else {
    try {
      const response = await api.get(`/SugestoesMelhoria/${idSugestao}`)
      const data = response.data
      if (data) {
        data.usuarioVoto = false
        data.comentarios = []
        sugestoes.value.unshift(data)
        expandedCard.value = idSugestao
        comentariosAbertos.value = idSugestao
        // Carrega comentários na página correta
        await carregarComentarios(data, paginaAlvo)

        // Se o comentário alvo é uma resposta, expande as respostas do pai
        if (idComentario && rootCommentId) {
          const rootComment = data.comentarios?.find(c => c.idSugestaoMelhoriaComentario === rootCommentId)
          if (rootComment) {
            respostasAbertas.add(rootCommentId)
            const temResposta = rootComment.respostas?.some(r => r.idSugestaoMelhoriaComentario === idComentario)
            if (!temResposta && rootComment.totalRespostas > (rootComment.respostas?.length || 0)) {
              await carregarMaisRespostas(data, rootComment)
            }
          }
        }

        if (idComentario) {
          comentarioDestacado.value = null
          await nextTick()
          comentarioDestacado.value = idComentario
          if (destacadoClearTimer) clearTimeout(destacadoClearTimer)
          destacadoClearTimer = setTimeout(() => {
            comentarioDestacado.value = null
            destacadoClearTimer = null
          }, 3500)
        }
        nextTick(() => {
          const card = document.querySelector(`[data-card-id="${idSugestao}"]`)
          if (card) card.scrollIntoView({ behavior: 'smooth', block: 'center' })
          // Scrolla a área de comentários para mostrar o comentário destacado
          if (idComentario) {
            const commentEl = document.querySelector(`[data-comment-id="${idComentario}"]`)
            if (commentEl) {
              const commentsList = commentEl.closest('.comments-list')
              if (commentsList) {
                commentEl.scrollIntoView({ behavior: 'smooth', block: 'center' })
              }
            }
          }
        })
      }
    } catch (error) {
      console.error('Erro ao buscar sugestão da notificação:', error)
    }
  }
}

// ==================== FASE 2: DÚVIDAS EM DESTAQUE / MAIORES DÚVIDAS ====================
const duvidasDestaque = ref([])
const duvidasModo = ref('destaque')
let duvidasTimer = null

const carregarDuvidasDestaque = async () => {
  try {
    const response = await api.get('/SugestoesMelhoria/duvidas-destaque', {
      params: { modo: duvidasModo.value },
      _suppressLoading: true
    })
    duvidasDestaque.value = response.data || []
  } catch (error) {
    console.error('Erro ao carregar dúvidas:', error)
    duvidasDestaque.value = []
  }
}

const reiniciarDuvidasTimer = () => {
  if (duvidasTimer) clearInterval(duvidasTimer)
  duvidasTimer = setInterval(() => {
    duvidasModo.value = duvidasModo.value === 'destaque' ? 'maiores' : 'destaque'
    carregarDuvidasDestaque()
  }, 8000)
}

// ==================== FASE 2: TÓPICOS EM ASCENSÃO ====================
const topicosQuentes = ref([])

const carregarTopicosQuentes = async () => {
  try {
    const response = await api.get('/SugestoesMelhoria/topicos-quentes', {
      params: { dias: 7 },
      _suppressLoading: true
    })
    topicosQuentes.value = response.data || []
  } catch (error) {
    console.error('Erro ao carregar tópicos em ascensão:', error)
    topicosQuentes.value = []
  }
}

const topicoQuenteMaxScore = computed(() => {
  if (topicosQuentes.value.length === 0) return 1
  return Math.max(...topicosQuentes.value.map(t => t.score), 1)
})

const topicoQuentePercent = (item) => {
  return Math.round((item.score / topicoQuenteMaxScore.value) * 100)
}

// ==================== CAROUSEL 4 ESTÁGIOS ====================
const carouselAtivo = ref(0)
const carouselEstagios = [
  { titulo: 'Sugestões em Ascensão', icone: 'bi-graph-up-arrow' },
  { titulo: 'Dúvidas em Destaque', icone: 'bi-question-circle' },
  { titulo: 'Hashtags em Ascensão', icone: 'bi-hash' },
  { titulo: 'Hashtags Populares', icone: 'bi-fire' }
]
let carouselTimer = null

const reiniciarCarouselTimer = () => {
  if (carouselTimer) clearInterval(carouselTimer)
  carouselTimer = setInterval(() => {
    carouselAtivo.value = (carouselAtivo.value + 1) % carouselEstagios.length
  }, 20000)
}

// Touch swipe para navegação do carrossel (mobile)
let carouselTouchStartX = 0
const onCarouselTouchStart = (e) => {
  carouselTouchStartX = e.touches[0].clientX
}

const onCarouselTouchEnd = (e) => {
  const diffX = e.changedTouches[0].clientX - carouselTouchStartX
  if (Math.abs(diffX) < 40) return // tolerância mínima
  if (diffX < 0) {
    // Swipe left → próximo estágio
    carouselAtivo.value = (carouselAtivo.value + 1) % carouselEstagios.length
  } else {
    // Swipe right → estágio anterior
    carouselAtivo.value = (carouselAtivo.value - 1 + carouselEstagios.length) % carouselEstagios.length
  }
  reiniciarCarouselTimer()
}
const hashtagsAscendentes = ref([])
const hashtagsPopulares = ref([])

const carregarHashtagsAscendentes = async () => {
  try {
    const response = await api.get('/SugestoesMelhoria/hashtags/ascendentes', {
      _suppressLoading: true
    })
    hashtagsAscendentes.value = response.data || []
  } catch { hashtagsAscendentes.value = [] }
}

const carregarHashtagsPopulares = async () => {
  try {
    const response = await api.get('/SugestoesMelhoria/hashtags/populares', {
      _suppressLoading: true
    })
    hashtagsPopulares.value = response.data || []
  } catch { hashtagsPopulares.value = [] }
}

const hashtagPercent = (item, lista) => {
  if (!lista || lista.length === 0) return 0
  const maxScore = Math.max(...lista.map(i => i.score), 1)
  return Math.round((item.score / maxScore) * 100)
}

// ==================== FASE 2: RADAR DA EQUIPE ====================
const atividadesRecentes = ref([])

const carregarAtividadesRecentes = async () => {
  try {
    const response = await api.get('/SugestoesMelhoria/atividade-recente', {
      _suppressLoading: true
    })
    atividadesRecentes.value = response.data || []
  } catch (error) {
    console.error('Erro ao carregar atividades recentes:', error)
    atividadesRecentes.value = []
  }
}

// ==================== FASE 2: FEEDBACK RECENTE ====================
const feedbackRecente = ref([])

const carregarFeedbackRecente = async () => {
  try {
    const response = await api.get('/SugestoesMelhoria', {
      params: {
        sortBy: 'dataAnalise',
        pageSize: 3,
        status: SUGEST_STATUS.Concluido
      },
      _suppressLoading: true
    })
    // Filtra apenas os que têm feedback preenchido
    feedbackRecente.value = (response.data || []).filter(s => s.feedbackAnalise)
  } catch (error) {
    console.error('Erro ao carregar feedback recente:', error)
    feedbackRecente.value = []
  }
}

// ==================== WIDGETS: MÓDULOS ====================
const modulosConteo = computed(() => {
  const mapa = new Map()
  sugestoes.value.forEach(s => {
    const mod = s.modulo || ''
    mapa.set(mod, (mapa.get(mod) || 0) + 1)
  })
  return Array.from(mapa.entries())
    .map(([modulo, count]) => ({ modulo, count }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 8)
})

// ==================== WIDGETS: MINHAS CONTRIBUIÇÕES ====================
const minhasStats = ref({ totalCriadas: 0, totalVotos: 0, totalComentarios: 0 })

const carregarMinhasStats = async () => {
  try {
    const response = await api.get('/SugestoesMelhoria/minhas-stats', {
      _suppressLoading: true
    })
    minhasStats.value = response.data || { totalCriadas: 0, totalVotos: 0, totalComentarios: 0 }
  } catch (error) {
    console.error('Erro ao carregar minhas stats:', error)
    minhasStats.value = { totalCriadas: 0, totalVotos: 0, totalComentarios: 0 }
  }
}

const filtrarMinhas = () => {
  filtroMinhas.value = !filtroMinhas.value
  if (filtroMinhas.value) filtroEquipe.value = false
  buscarDados(1)
}

const filtrarEquipe = () => {
  filtroEquipe.value = !filtroEquipe.value
  if (filtroEquipe.value) filtroMinhas.value = false
  buscarDados(1)
}

const filtrarSalvas = () => {
  filtroSalvas.value = !filtroSalvas.value
  if (filtroSalvas.value) {
    filtroMinhas.value = false
    filtroEquipe.value = false
  }
  buscarDados(1)
}

// ==================== EMOJIS ====================
const emojis = [
  '😀', '😂', '❤️', '🔥', '👍', '👏', '🎉', '💡',
  '🚀', '✅', '⭐', '💪', '🙌', '👀', '💯', '🔝',
  '😍', '🤩', '🥳', '✨', '🌟', '💥', '📈', '🎯',
  '🙏', '💜', '🫶', '😎', '🤝', '💚', '🧠', '👊'
]

// ==================== AVATAR ====================
const avatarColors = ['#e74c3c', '#3498db', '#2ecc71', '#f39c12', '#9b59b6', '#1abc9c', '#e67e22', '#16a085', '#e84393', '#6c5ce7']

const getAvatarColor = (name) => {
  if (!name) return avatarColors[0]
  let hash = 0
  const str = String(name)
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  return avatarColors[Math.abs(hash) % avatarColors.length]
}

const getAvatarInitial = (name) => {
  if (!name) return '?'
  return String(name).charAt(0).toUpperCase()
}

// ==================== @MENTIONS ====================
const renderComentario = (texto) => {
  if (!texto) return ''
  // Converte @menções em links clicáveis
  return texto.replace(/@(\w{3,30})/g, '<a href="#" class="mention-link" onclick="event.preventDefault()">@$1</a>')
}

// ==================== HASHTAGS ====================
const renderizarHashtags = (texto) => {
  if (!texto) return ''
  // Converte #palavra em links clicáveis
  return texto.replace(/#(\w{2,50})/g, '<a href="#" class="hashtag-link" data-hashtag="$1">#$1</a>')
}

// ==================== DESCRIÇÃO (MARKDOWN + HASHTAGS) ====================
// A descrição é gerada pela IA no formato Markdown estruturado (Pergunta/Resposta).
// Renderiza o Markdown (sanitizado) e converte #hashtags em links clicáveis.
const renderizarDescricao = (texto) => renderizarMarkdown(texto, { hashtags: true })

const onCardBodyClick = (sugestao, event) => {
  const hashtagLink = event.target.closest('.hashtag-link')
  if (hashtagLink) {
    event.preventDefault()
    event.stopPropagation()
    const tag = hashtagLink.dataset.hashtag
    if (tag) {
      filtroHashtag.value = tag
      buscarDados(1)
    }
    return
  }
  // Se não clicou em hashtag, comportamento normal de expandir
  toggleExpand(sugestao.idSugestaoMelhoria)
}

const mentionSuggestions = ref([])
const mentionSearch = ref('')
const showMentionDropdown = ref(false)
const activeSugestaoId = ref(null)
const selectedMentionIndex = ref(0)
let mentionTimeout = null

const buscarMentions = async (query, sugestaoId) => {
  try {
    const params = { q: query || '' }
    if (sugestaoId) params.sugestaoId = sugestaoId
    const response = await api.get('/Usuarios/para-mention', { params })
    mentionSuggestions.value = response.data || []
    selectedMentionIndex.value = 0
    showMentionDropdown.value = mentionSuggestions.value.length > 0
  } catch {
    mentionSuggestions.value = []
    showMentionDropdown.value = false
  }
}

const onCommentInput = (sugestaoId, event) => {
  const input = event.target
  const texto = input.value
  const cursorPos = input.selectionStart
  const textoAteCursor = texto.substring(0, cursorPos)

  // Detecta @ sendo digitado
  const match = textoAteCursor.match(/@(\w*)$/)
  if (match) {
    const searchTerm = match[1]
    if (mentionTimeout) clearTimeout(mentionTimeout)
    mentionTimeout = setTimeout(() => {
      activeSugestaoId.value = sugestaoId
      mentionSearch.value = searchTerm
      buscarMentions(searchTerm, sugestaoId)
    }, 150)
  } else {
    showMentionDropdown.value = false
  }
}

const onCommentArrow = (sugestao, delta) => {
  if (!showMentionDropdown.value || activeSugestaoId.value !== sugestao.idSugestaoMelhoria) return
  const total = mentionSuggestions.value.length
  if (total === 0) return
  selectedMentionIndex.value = (selectedMentionIndex.value + delta + total) % total
}

const onCommentKeydown = (sugestao, event) => {
  if (showMentionDropdown.value && event.key === 'Enter') {
    event.preventDefault()
    const usuario = mentionSuggestions.value[selectedMentionIndex.value]
    if (usuario) {
      selecionarMention(usuario)
    }
    return
  }
  // Se não há dropdown aberto, Enter envia o comentário
  enviarComentario(sugestao)
}

const selecionarMention = (usuario) => {
  const sugestaoId = activeSugestaoId.value
  if (!sugestaoId || !novoComentario[sugestaoId]) return

  const texto = novoComentario[sugestaoId]
  const match = texto.match(/@(\w*)$/)
  if (match) {
    const before = texto.substring(0, texto.lastIndexOf('@'))
    novoComentario[sugestaoId] = before + `@${usuario.apelido} `
  }
  showMentionDropdown.value = false
  mentionSuggestions.value = []
  nextTick(() => {
    const inputs = document.querySelectorAll('.comment-input-field')
    const lastInput = inputs[inputs.length - 1]
    if (lastInput) lastInput.focus()
  })
}

// ==================== TIME UTILS ====================
const timeAgo = (dateStr) => {
  if (!dateStr) return ''
  const date = new Date(dateStr)
  const now = new Date()
  const diffMs = now - date
  const diffMin = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMs / 3600000)
  const diffDays = Math.floor(diffMs / 86400000)

  if (diffMin < 1) return 'agora'
  if (diffMin < 60) return `${diffMin}m atrás`
  if (diffHours < 24) return `${diffHours}h atrás`
  if (diffDays < 7) return `${diffDays}d atrás`
  return date.toLocaleDateString('pt-BR')
}

const formatarDataBR = (dateStr) => {
  if (!dateStr) return '-'
  try {
    const d = new Date(dateStr)
    return d.toLocaleDateString('pt-BR', { timeZone: 'UTC' })
  } catch {
    return String(dateStr)
  }
}

// ==================== BADGES ====================
const getTipoKey = (codigo) => {
  if (!codigo) return 'default'
  if (codigo.includes('TIPO1')) return 'sugestao'
  if (codigo.includes('TIPO2')) return 'bug'
  if (codigo.includes('TIPO3')) return 'nova'
  if (codigo.includes('TIPO4')) return 'duda'
  return 'default'
}

const getTipoIcon = (codigo) => {
  if (!codigo) return 'bi-lightbulb'
  if (codigo.includes('TIPO1')) return 'bi-lightbulb'
  if (codigo.includes('TIPO2')) return 'bi-bug'
  if (codigo.includes('TIPO3')) return 'bi-stars'
  if (codigo.includes('TIPO4')) return 'bi-question-circle'
  return 'bi-lightbulb'
}

const getStatusIcon = (codigo) => {
  if (!codigo) return 'bi-circle'
  const nome = getStatusTexto(codigo)
  if (nome === 'Pendente') return 'bi-hourglass-split'
  if (nome === 'EmAnalise') return 'bi-search'
  if (nome === 'Planejado') return 'bi-clipboard-check'
  if (nome === 'EmDesenvolvimento') return 'bi-code-slash'
  if (nome === 'Concluido') return 'bi-check2-all'
  if (nome === 'Rejeitado') return 'bi-x-octagon'
  if (nome === 'Banido') return 'bi-slash-circle'
  return 'bi-circle'
}

const getStatusBadge = (codigo) => {
  if (!codigo) return 'badge-status badge-status-pendente'
  const nome = getStatusTexto(codigo)
  if (nome === 'Pendente') return 'badge-status badge-status-pendente'
  if (nome === 'EmAnalise') return 'badge-status badge-status-analise'
  if (nome === 'Planejado') return 'badge-status badge-status-planejado'
  if (nome === 'EmDesenvolvimento') return 'badge-status badge-status-desenvolvimento'
  if (nome === 'Concluido') return 'badge-status badge-status-concluido'
  if (nome === 'Rejeitado') return 'badge-status badge-status-rejeitado'
  if (nome === 'Banido') return 'badge-status badge-status-banido'
  return 'badge-status badge-status-pendente'
}

const getStatusTexto = (codigo) => {
  const entry = Object.entries(SUGEST_STATUS).find(([, v]) => v === codigo)
  return entry ? entry[0] : codigo
}

const getTipoTexto = (codigo) => {
  const entry = Object.entries(SUGEST_TIPO).find(([, v]) => v === codigo)
  return entry ? entry[0] : codigo
}

const getPriorTexto = (codigo) => {
  const entry = Object.entries(SUGEST_PRIOR).find(([, v]) => v === codigo)
  return entry ? entry[0] : codigo
}

const getPriorBadge = (codigo) => {
  if (codigo === 'SUGEST_PRIOR4') return 'badge-prior badge-prior-critica'
  if (codigo === 'SUGEST_PRIOR3') return 'badge-prior badge-prior-alta'
  if (codigo === 'SUGEST_PRIOR2') return 'badge-prior badge-prior-media'
  return 'badge-prior badge-prior-baixa'
}

// ==================== DADOS ====================
const buscarDados = async (page = 1) => {
  isLoading.value = true
  try {
    const params = {
      page,
      pageSize: paginacao.PageSize,
      sortBy: ordenacao.value === 'votos' ? 'votos' : 'tsCriacao'
    }
    if (filtroBusca.value) params.q = filtroBusca.value
    if (filtroStatus.value) params.status = filtroStatus.value
    if (filtroTipo.value) params.tipo = filtroTipo.value
    if (filtroModulo.value) params.modulo = filtroModulo.value
    if (filtroMinhas.value && idUsuarioLogado.value) params.idUsuarioCriacao = idUsuarioLogado.value
    if (filtroEquipe.value) params.equipe = true
    if (filtroHashtag.value) params.hashtag = filtroHashtag.value
    if (filtroDenuncias.value === 'comDenuncias') params.comDenuncias = true
    if (filtroDenuncias.value === 'banidas') {
      params.status = SUGEST_STATUS.Banido
      filtroStatus.value = '' // limpa para evitar conflito com filtro de status
    }
    if (filtroSalvas.value) params.salvas = true

    const response = await api.get('/SugestoesMelhoria', { params })
    const data = response.data

    // Mapeia os votos do usuário atual
    if (page === 1) {
      sugestoes.value = data.map(s => ({ ...s, usuarioVoto: false, usuarioSalvou: false, comentarios: [] }))
    } else {
      const novas = data.map(s => ({ ...s, usuarioVoto: false, usuarioSalvou: false, comentarios: [] }))
      sugestoes.value = [...sugestoes.value, ...novas]
    }

    // Verifica se o usuário já votou em cada sugestão
    await verificarVotosUsuario()

    // Verifica quais sugestões estão salvas pelo usuário
    if (page === 1) {
      try {
        const responseSalvas = await api.get('/SugestoesMelhoria/salvas', {
          _suppressLoading: true
        })
        const idsSalvos = responseSalvas.data || []
        sugestoes.value.forEach(s => {
          s.usuarioSalvou = idsSalvos.includes(s.idSugestaoMelhoria)
        })
      } catch {
        // ignora
      }
    }

    const pagination = response.headers['x-pagination']
    if (pagination) {
      const parsed = JSON.parse(pagination)
      paginacao.TotalCount = parsed.TotalCount
      paginacao.PageSize = parsed.PageSize
      paginacao.CurrentPage = parsed.CurrentPage
    }
  } catch (error) {
    console.error('Erro ao buscar sugestões:', error)
  } finally {
    isLoading.value = false
  }
}

const verificarVotosUsuario = async () => {
  try {
    const response = await api.get('/SugestoesMelhoria/votos/usuario', {
      _suppressLoading: true
    })
    const votosUsuario = response.data || []
    sugestoes.value.forEach(s => {
      s.usuarioVoto = votosUsuario.includes(s.idSugestaoMelhoria)
    })
  } catch {
    // Se o endpoint não existe, ignora
  }
}

const carregarMais = () => {
  if (!hasMorePages.value || isLoading.value) return
  buscarDados(paginacao.CurrentPage + 1)
}

const limparFiltros = () => {
  filtroBusca.value = ''
  filtroStatus.value = ''
  filtroTipo.value = ''
  filtroModulo.value = ''
  filtroMinhas.value = false
  filtroEquipe.value = false
  filtroHashtag.value = ''
  filtroDenuncias.value = ''
  filtroSalvas.value = false
  buscarDados(1)
}

const filtrarModulo = (modulo) => {
  filtroModulo.value = filtroModulo.value === modulo ? '' : modulo
  buscarDados(1)
}

// ==================== EXPANDIR CARD ====================
const toggleExpand = (id) => {
  expandedCard.value = expandedCard.value === id ? null : id
}

// ==================== VOTAÇÃO ====================
const showCurtidoresModal = ref(false)
const curtidoresModalTitulo = ref('')

// --- Empilhamento (z-index) via registry central ---
const zIndexCurtidores = ref(BASE_ZINDEX)
const tokenCurtidores = ref(null)

watch(showCurtidoresModal, (aberto) => {
  if (aberto) {
    const { token, zIndex: z } = reservarZIndex()
    tokenCurtidores.value = token
    zIndexCurtidores.value = z
  } else {
    liberarZIndex(tokenCurtidores.value)
    tokenCurtidores.value = null
  }
})
const curtidoresLista = ref([])
const curtidoresLoading = ref(false)

const fecharCurtidoresPopup = () => {
  showCurtidoresModal.value = false
}

const abrirCurtidoresSugestao = async (sugestao) => {
  curtidoresModalTitulo.value = `Curtidas em "${sugestao.titulo}"`
  curtidoresLoading.value = true
  showCurtidoresModal.value = true
  try {
    const response = await api.get(`/SugestoesMelhoria/${sugestao.idSugestaoMelhoria}/curtidores`)
    curtidoresLista.value = response.data || []
  } catch {
    curtidoresLista.value = []
  } finally {
    curtidoresLoading.value = false
  }
}

const abrirCurtidoresComentario = async (sugestao, comentario) => {
  curtidoresModalTitulo.value = 'Curtidas no comentário'
  curtidoresLoading.value = true
  showCurtidoresModal.value = true
  try {
    const response = await api.get(`/SugestoesMelhoria/${sugestao.idSugestaoMelhoria}/comentarios/${comentario.idSugestaoMelhoriaComentario}/curtidores`)
    curtidoresLista.value = response.data || []
  } catch {
    curtidoresLista.value = []
  } finally {
    curtidoresLoading.value = false
  }
}

const votar = async (sugestao) => {
  try {
    const response = await api.post(`/SugestoesMelhoria/${sugestao.idSugestaoMelhoria}/votar`)
    sugestao.votosPositivos = response.data.votosPositivos
    sugestao.usuarioVoto = response.data.usuarioVoto
  } catch (error) {
    console.error('Erro ao votar:', error)
  }
}

// ==================== SALVAR (BOOKMARK) ====================

const toggleSalvar = async (sugestao) => {
  try {
    if (sugestao.usuarioSalvou) {
      await api.delete(`/SugestoesMelhoria/${sugestao.idSugestaoMelhoria}/salvar`)
      sugestao.usuarioSalvou = false
      // Remove do widget de salvos
      sugestoesSalvas.value = sugestoesSalvas.value.filter(s => s.idSugestaoMelhoria !== sugestao.idSugestaoMelhoria)
    } else {
      await api.post(`/SugestoesMelhoria/${sugestao.idSugestaoMelhoria}/salvar`)
      sugestao.usuarioSalvou = true
      // Adiciona ao topo do widget de salvos
      sugestoesSalvas.value.unshift({
        idSugestaoMelhoria: sugestao.idSugestaoMelhoria,
        titulo: sugestao.titulo,
        modulo: sugestao.modulo,
        lstStatusSugestao: sugestao.lstStatusSugestao
      })
    }
  } catch (error) {
    const msg = error.response?.data?.message || 'Erro ao salvar.'
    emit('show-notification', { type: 'error', message: msg })
  }
}

const carregarSugestoesSalvas = async () => {
  try {
    const response = await api.get('/SugestoesMelhoria/salvas/detalhes', {
      _suppressLoading: true
    })
    sugestoesSalvas.value = response.data || []
  } catch {
    sugestoesSalvas.value = []
  }
}

// ==================== COMENTÁRIOS ====================
const comentariosPagination = reactive({})
const respostasAbertas = reactive(new Set())
const carregandoMaisComentarios = ref(false)

const toggleComentarios = async (sugestao) => {
  if (comentariosAbertos.value === sugestao.idSugestaoMelhoria) {
    comentariosAbertos.value = null
    return
  }
  comentariosAbertos.value = sugestao.idSugestaoMelhoria
  if (!sugestao.comentarios || sugestao.comentarios.length === 0) {
    await carregarComentarios(sugestao, 1)
  }
}

const carregarComentarios = async (sugestao, page = 1) => {
  try {
    const response = await api.get(`/SugestoesMelhoria/${sugestao.idSugestaoMelhoria}/comentarios`, {
      params: { page, pageSize: 5, repliesPageSize: 3 }
    })
    const data = response.data || []
    if (page === 1) {
      sugestao.comentarios = data
    } else {
      sugestao.comentarios = [...(sugestao.comentarios || []), ...data]
    }
    sugestao.totalComentarios = sugestao.comentarios.length

    // Paginação
    const pagination = response.headers['x-pagination']
    if (pagination) {
      const parsed = JSON.parse(pagination)
      comentariosPagination[sugestao.idSugestaoMelhoria] = {
        currentPage: page,
        pageSize: parsed.PageSize,
        totalCount: parsed.TotalCount,
        hasMore: parsed.HasNext
      }
    }
  } catch (error) {
    console.error('Erro ao carregar comentários:', error)
    sugestao.comentarios = []
  }
}

const carregarMaisComentarios = async (sugestao) => {
  const pag = comentariosPagination[sugestao.idSugestaoMelhoria]
  if (!pag || !pag.hasMore || carregandoMaisComentarios.value) return
  carregandoMaisComentarios.value = true
  await carregarComentarios(sugestao, pag.currentPage + 1)
  carregandoMaisComentarios.value = false
}

const toggleRespostas = async (comentario) => {
  const id = comentario.idSugestaoMelhoriaComentario
  if (respostasAbertas.has(id)) {
    respostasAbertas.delete(id)
  } else {
    respostasAbertas.add(id)
  }
}

const carregarMaisRespostas = async (sugestao, comentario) => {
  const currentCount = comentario.respostas?.length || 0
  try {
    const response = await api.get(
      `/SugestoesMelhoria/${sugestao.idSugestaoMelhoria}/comentarios/${comentario.idSugestaoMelhoriaComentario}/respostas`,
      { params: { page: Math.floor(currentCount / 3) + 1, pageSize: 3 } }
    )
    const novasRespostas = response.data || []
    comentario.respostas = [...(comentario.respostas || []), ...novasRespostas]
  } catch (error) {
    console.error('Erro ao carregar mais respostas:', error)
  }
}

const enviarComentario = async (sugestao) => {
  const sugestaoId = sugestao.idSugestaoMelhoria
  const texto = novoComentario[sugestaoId]
  if (!texto?.trim()) return

  const payload = { comentario: texto.trim() }
  // Se está respondendo a um comentário, inclui o IdComentarioPai
  if (respondendoA.value?.sugestaoId === sugestaoId) {
    payload.idComentarioPai = respondendoA.value.idComentarioPai
  }

  try {
    await api.post(`/SugestoesMelhoria/${sugestaoId}/comentarios`, payload)
    novoComentario[sugestaoId] = ''
    respondendoA.value = null
    await carregarComentarios(sugestao)
  } catch (error) {
    console.error('Erro ao enviar comentário:', error)
  }
}

const respondendoA = ref(null)

const cancelarResposta = () => {
  const sugestaoId = respondendoA.value?.sugestaoId
  if (sugestaoId && novoComentario[sugestaoId]) {
    novoComentario[sugestaoId] = ''
  }
  respondendoA.value = null
}

const responderComentario = (sugestao, comentario) => {
  const sugestaoId = sugestao.idSugestaoMelhoria
  if (respondendoA.value?.sugestaoId === sugestaoId && respondendoA.value?.idComentarioPai === comentario.idSugestaoMelhoriaComentario) {
    respondendoA.value = null
    return
  }
  // Se o comentário já é filho (tem idComentarioPai), usa o pai raiz para que a resposta seja irmã
  const idComentarioPai = comentario.idComentarioPai || comentario.idSugestaoMelhoriaComentario
  respondendoA.value = {
    sugestaoId,
    apelido: comentario.apelidoUsuario || comentario.nomeUsuario || 'Usuário',
    idComentarioPai,
    idComentarioAlvo: comentario.idSugestaoMelhoriaComentario
  }
  if (!novoComentario[sugestaoId]) {
    novoComentario[sugestaoId] = ''
  }
  novoComentario[sugestaoId] = `@${respondendoA.value.apelido} `
  nextTick(() => {
    const inputs = document.querySelectorAll('.comment-input-field')
    const lastInput = inputs[inputs.length - 1]
    if (lastInput) lastInput.focus()
  })
}

const curtirComentario = async (sugestao, comentario) => {
  try {
    const response = await api.post(`/SugestoesMelhoria/${sugestao.idSugestaoMelhoria}/comentarios/${comentario.idSugestaoMelhoriaComentario}/curtir`)
    comentario.curtidas = response.data.curtidas
    comentario.usuarioCurtiu = response.data.usuarioCurtiu
  } catch (error) {
    console.error('Erro ao curtir comentário:', error)
  }
}

// ==================== EXCLUIR COMENTÁRIO ====================
const eliminarComentario = async (sugestao, comentario) => {
  mostrarConfirmacao(
    'Excluir comentário',
    'Tem certeza que deseja excluir este comentário permanentemente?',
    async () => {
      try {
        await api.delete(`/SugestoesMelhoria/${sugestao.idSugestaoMelhoria}/comentarios/${comentario.idSugestaoMelhoriaComentario}`)
        emit('show-notification', { type: 'success', message: 'Comentário excluído com sucesso.' })
        await carregarComentarios(sugestao)
      } catch (error) {
        const data = error.response?.data
        const msg = data?.message || 'Erro ao excluir comentário.'
        emit('show-notification', { type: 'error', message: msg })
      }
    }
  )
}

// ==================== EMOJI PICKER ====================
const toggleEmojiPicker = (id) => {
  emojiPickerOpen.value = emojiPickerOpen.value === id ? null : id
}

const inserirEmoji = (sugestaoId, emoji) => {
  if (!novoComentario[sugestaoId]) {
    novoComentario[sugestaoId] = ''
  }
  novoComentario[sugestaoId] += emoji
}

const fecharEmojiPicker = (e) => {
  if (!e.target.closest('.btn-emoji-picker') && !e.target.closest('.emoji-picker-popup')) {
    emojiPickerOpen.value = null
  }
}

// ==================== ADMIN ====================
const abrirAdminModal = (sugestao) => {
  sugestaoAdminSelecionada.value = sugestao
  editStatus.value = sugestao.lstStatusSugestao || ''
  editPrioridade.value = sugestao.lstPrioridadeSugestao || ''
  editFeedback.value = sugestao.feedbackAnalise || ''
  showAdminModal.value = true
}

const salvarAdmin = async () => {
  if (!sugestaoAdminSelecionada.value) return
  isSavingAdmin.value = true
  try {
    await api.put(`/SugestoesMelhoria/${sugestaoAdminSelecionada.value.idSugestaoMelhoria}`, {
      lstStatusSugestao: editStatus.value,
      lstPrioridadeSugestao: editPrioridade.value,
      feedbackAnalise: editFeedback.value
    })
    emit('show-notification', { type: 'success', message: 'Sugestão atualizada com sucesso!' })
    showAdminModal.value = false
    buscarDados(paginacao.CurrentPage)
  } catch (error) {
    emit('show-notification', { type: 'danger', message: 'Erro ao atualizar sugestão.' })
  } finally {
    isSavingAdmin.value = false
  }
}

const abrirFeedback = (sugestao) => {
  sugestaoFeedback.value = sugestao
  showFeedbackModal.value = true
}

const eliminar = async (sugestao) => {
  mostrarConfirmacao(
    'Excluir sugestão',
    `Tem certeza que deseja excluir a sugestão "${sugestao.titulo}" permanentemente?`,
    async () => {
      try {
        await api.delete(`/SugestoesMelhoria/${sugestao.idSugestaoMelhoria}`)
        emit('show-notification', { type: 'success', message: 'Sugestão eliminada.' })
        buscarDados(paginacao.CurrentPage)
      } catch (error) {
        emit('show-notification', { type: 'danger', message: 'Erro ao eliminar.' })
      }
    }
  )
}

// ==================== NOVA SUGESTÃO ====================
const abrirNovaSugestao = () => {
  contextoAtual.value = {
    modulo: 'Sugestões',
    tela: 'Sugestões de Melhorias',
    rota: window.location.hash || '',
    versaoSistema: process.env.VUE_APP_VERSION || '',
    nomeUsuario: nomeUtilizador.value || ''
  }
  showChatModal.value = true
}

// ==================== PERFIL DO USUÁRIO ====================
const carregarMeuPerfil = async () => {
  if (!idUsuarioLogado.value) return
  try {
    const response = await api.get(`/Usuarios/${idUsuarioLogado.value}`)
    meuPerfil.value = response.data
  } catch {
    meuPerfil.value = null
  }
}

const onSugestoesSalvas = () => {
  emit('show-notification', { type: 'success', message: 'Sugestões salvas com sucesso!' })
  buscarDados(1)
  carregarResumoStatus()
  carregarTopVotados()
  carregarDuvidasDestaque()
  carregarTopicosQuentes()
  carregarHashtagsAscendentes()
  carregarHashtagsPopulares()
  carregarAtividadesRecentes()
  carregarFeedbackRecente()
  carregarMinhasStats()
}

// ==================== ATUALIZAR FEED (MOBILE) ====================
const atualizarFeed = () => {
  // Rola o container de scroll para o topo
  const container = document.querySelector('.list-container')
  if (container) {
    container.scrollTo({ top: 0, behavior: 'smooth' })
  } else {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  // Recarrega todos os dados
  buscarDados(1)
  carregarResumoStatus()
  carregarTopVotados()
  carregarDuvidasDestaque()
  carregarTopicosQuentes()
  carregarHashtagsAscendentes()
  carregarHashtagsPopulares()
  carregarAtividadesRecentes()
  carregarFeedbackRecente()
  carregarMinhasStats()
  carregarSugestoesSalvas()
}

// ==================== LIFECYCLE ====================
onMounted(() => {
  // Mede altura do header global e seta CSS var
  const headerEl = document.querySelector('.admin-header-global')
  headerOffset.value = headerEl ? headerEl.offsetHeight : 56
  document.documentElement.style.setProperty('--feed-header-h', headerOffset.value + 'px')

  carregarMeuPerfil()
  buscarDados(1)
  carregarResumoStatus()
  carregarTopVotados()
  carregarDuvidasDestaque()
  carregarTopicosQuentes()
  carregarHashtagsAscendentes()
  carregarHashtagsPopulares()
  carregarAtividadesRecentes()
  carregarFeedbackRecente()
  carregarMinhasStats()
  carregarDenunciasPendentes()
  carregarSugestoesSalvas()
  reiniciarDuvidasTimer()
  reiniciarCarouselTimer()
  document.addEventListener('click', fecharEmojiPicker)
  window.addEventListener('resize', handleResize)
  nextTick(() => setupScrollObserver())
})

// Reconfigura o observer quando muda entre desktop/mobile
watch(isDesktop, (desktop) => {
  destroyScrollObserver()
  if (!desktop) nextTick(() => setupScrollObserver())
})

onUnmounted(() => {
  if (duvidasTimer) clearInterval(duvidasTimer)
  if (carouselTimer) clearInterval(carouselTimer)
  document.removeEventListener('click', fecharEmojiPicker)
  window.removeEventListener('resize', handleResize)
  destroyScrollObserver()
  liberarZIndex(tokenDrawer.value)
  liberarZIndex(tokenCurtidores.value)
  tokenDrawer.value = null
  tokenCurtidores.value = null
})

defineExpose({ buscarDados })
</script>

<style scoped>
/* ========================
   VARIÁVEIS DE COR - TEMA SUGESTÕES (Roxo/Violeta)
   ======================== */
.sugestoes-feed {
  --feed-primary: #8B5CF6;
  --feed-primary-light: #A78BFA;
  --feed-primary-dark: #7C3AED;
  --feed-primary-deep: #6D28D9;
  --feed-primary-bg: #F5F3FF;
  --feed-primary-border: #DDD6FE;
  --feed-card-bg: var(--bs-body-bg);
  --feed-card-border: var(--bs-border-color-translucent);
  --feed-text: var(--bs-body-color);
  --feed-text-secondary: var(--bs-secondary-color);
  --feed-shadow: 0 1px 3px rgba(0,0,0,0.08);
  --feed-shadow-hover: 0 4px 12px rgba(139, 92, 246, 0.12);
  --feed-radius: 12px;
  --feed-transition: all 0.2s ease;
  --feed-rosa: #EC4899;
  --feed-ambar: #F59E0B;
  --feed-esmeralda: #10B981;
  --feed-azul: #3B82F6;
  --feed-naranja: #F97316;
}

[data-bs-theme="dark"] .sugestoes-feed {
  --feed-primary-bg: #1E1B2E;
  --feed-primary-border: #2D2840;
  --feed-shadow: 0 1px 3px rgba(0,0,0,0.2);
  --feed-shadow-hover: 0 4px 12px rgba(139, 92, 246, 0.2);
  --feed-rosa: #F472B6;
  --feed-ambar: #FBBF24;
  --feed-esmeralda: #34D399;
  --feed-azul: #60A5FA;
  --feed-naranja: #FB923C;
}

/* ========================
   LAYOUT 3 COLUNAS
   ======================== */
.feed-layout {
  display: grid;
  grid-template-columns: 240px minmax(0, 1fr) 280px;
  gap: 1rem;
  align-items: start;
  max-width: 1400px;
  margin: 0 auto;
}

.feed-sidebar {
  position: sticky;
  top: 1rem;
  align-self: start;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.feed-sidebar-right {
  max-height: calc(100vh - 2rem);
  overflow-y: auto;
}

.feed-main {
  min-width: 0;
  overflow-y: auto;
}

/* ========================
   SIDEBAR COMUM
   ======================== */
.sidebar-block,
.sidebar-widget {
  background: var(--feed-card-bg);
  border: 1px solid var(--feed-card-border);
  border-radius: var(--feed-radius);
  padding: 0.9rem;
  box-shadow: var(--feed-shadow);
}

.sidebar-title,
.widget-title {
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--feed-primary);
  margin-bottom: 0.6rem;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

/* ========================
   SIDEBAR ESQUERDA: PERFIL
   ======================== */
.sidebar-profile {
  background: linear-gradient(135deg, #F5F3FF, #EDE9FE);
  color: var(--feed-text);
  border: 1px solid var(--feed-primary-border);
  position: relative;
  padding: 0.75rem;
}

.profile-top-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.profile-bell {
  margin-top: 0.25rem;
  flex-shrink: 0;
}

[data-bs-theme="dark"] .sidebar-profile {
  background: linear-gradient(135deg, #1E1B2E, #2D2840);
  border-color: var(--feed-primary-border);
}

.profile-avatar-ring {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid var(--feed-primary-border);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.profile-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 1.1rem;
}

.profile-info {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.5rem;
}

.profile-name {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--feed-primary-dark);
}

[data-bs-theme="dark"] .profile-name {
  color: var(--feed-primary-light);
}

.profile-stats {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
  background: var(--feed-primary-bg);
  border: 1px solid var(--feed-primary-border);
  border-radius: 10px;
  padding: 0.4rem 0.6rem;
}

.profile-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.stat-value {
  font-size: 1rem;
  font-weight: 800;
  color: var(--feed-primary);
}

.stat-label {
  font-size: 0.6rem;
  color: var(--feed-text-secondary);
  text-transform: uppercase;
}

/* ========================
   SIDEBAR ESQUERDA: NAVEGAÇÃO
   ======================== */
.sidebar-nav-item,
.sidebar-module-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.45rem 0.6rem;
  border: none;
  background: transparent;
  color: var(--feed-text);
  border-radius: 8px;
  font-size: 0.82rem;
  cursor: pointer;
  transition: var(--feed-transition);
  text-align: left;
}

.sidebar-nav-item:hover,
.sidebar-module-item:hover {
  background: var(--feed-primary-bg);
  color: var(--feed-primary);
}

.sidebar-nav-item.active,
.sidebar-module-item.active {
  background: linear-gradient(135deg, var(--feed-primary), var(--feed-primary-dark));
  color: white;
  font-weight: 600;
}

.nav-count {
  margin-left: auto;
  background: var(--feed-primary-bg);
  color: var(--feed-primary);
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0.1rem 0.5rem;
  border-radius: 999px;
  min-width: 1.6rem;
  text-align: center;
}

.sidebar-nav-item.active .nav-count,
.sidebar-module-item.active .nav-count {
  background: rgba(255,255,255,0.2);
  color: white;
}

.module-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sidebar-empty {
  font-size: 0.75rem;
  color: var(--feed-text-secondary);
  padding: 0.5rem;
}

/* ========================
   BOOKMARK BUTTON (CARD)
   ======================== */
.btn-action-saved {
  color: #8B5CF6 !important;
}

.btn-action-saved i {
  color: #8B5CF6;
}

/* ========================
   HEADER
   ======================== */
.feed-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.feed-header-icon {
  font-size: 1.5rem;
  color: var(--feed-primary);
}

.badge-feed-count {
  background: var(--feed-primary);
  color: white;
  font-size: 0.75rem;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
}

.btn-feed-primary {
  background: linear-gradient(135deg, var(--feed-primary), var(--feed-primary-dark));
  color: white;
  border: none;
  padding: 0.5rem 1.25rem;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.875rem;
  transition: var(--feed-transition);
  box-shadow: 0 2px 8px rgba(139, 92, 246, 0.3);
}

.btn-feed-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(139, 92, 246, 0.4);
  color: white;
}

/* ========================
   COMPOSER (REDE SOCIAL)
   ======================== */
.feed-composer {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: var(--feed-card-bg);
  border: 1px solid var(--feed-primary-border);
  border-radius: 999px;
  padding: 0.6rem 1rem;
  box-shadow: var(--feed-shadow);
  margin-bottom: 0.75rem;
}

.composer-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 1rem;
  flex-shrink: 0;
  border: 2px solid var(--feed-primary-light);
}

.composer-input {
  flex: 1;
  border: none;
  background: var(--feed-primary-bg);
  color: var(--feed-text-secondary);
  border-radius: 999px;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  text-align: left;
  cursor: pointer;
  transition: var(--feed-transition);
}

.composer-input:hover {
  background: var(--feed-primary-border);
  color: var(--feed-primary);
}

.btn-composer-send {
  padding: 0.4rem 1rem;
  font-size: 0.8rem;
}

/* ========================
   FILTROS
   ======================== */
.feed-filters {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.5rem 0;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
  border-bottom: 1px solid var(--feed-card-border);
}

.filter-group {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
}

.filter-select {
  min-width: 140px;
  border-radius: 8px;
  border-color: var(--feed-primary-border);
}

.filter-input {
  width: 150px;
  border-radius: 8px;
  border-color: var(--feed-primary-border);
}

.filter-select:focus, .filter-input:focus {
  border-color: var(--feed-primary);
  box-shadow: 0 0 0 0.2rem rgba(139, 92, 246, 0.15);
}

.btn-outline-feed {
  border: 1px solid var(--feed-primary-border);
  color: var(--feed-text);
  border-radius: 8px;
  transition: var(--feed-transition);
}

.btn-outline-feed:hover, .btn-outline-feed.active {
  background: var(--feed-primary-bg);
  border-color: var(--feed-primary);
  color: var(--feed-primary);
}

.filter-order {
  display: flex;
  gap: 0.25rem;
}

/* ========================
   CHIPS DE FILTRO ATIVO
   ======================== */
.feed-active-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-bottom: 0.75rem;
}

.active-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  background: var(--feed-primary-bg);
  color: var(--feed-primary);
  border: 1px solid var(--feed-primary-border);
  border-radius: 999px;
  padding: 0.2rem 0.6rem;
  font-size: 0.75rem;
  font-weight: 600;
}

.chip-close {
  background: none;
  border: none;
  color: var(--feed-primary);
  font-size: 0.7rem;
  padding: 0;
  cursor: pointer;
  line-height: 1;
}

/* ========================
   LOADING
   ======================== */
.feed-loading {
  display: flex;
  justify-content: center;
  padding: 3rem 0;
}

.text-feed-primary {
  color: var(--feed-primary);
}

/* ========================
   FEED CARDS
   ======================== */
.feed-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.feed-card {
  background: var(--bs-tertiary-bg);
  border: 1px solid var(--feed-card-border);
  border-radius: var(--feed-radius);
  padding: 1.25rem;
  box-shadow: var(--feed-shadow);
  transition: var(--feed-transition);
  position: relative;
}

/* Faixa lateral colorida por tipo */
.feed-card::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  border-radius: 4px 0 0 4px;
}

.feed-card-sugestao::before { background: linear-gradient(180deg, #4338CA, #8B5CF6); }
.feed-card-bug::before { background: linear-gradient(180deg, #DC2626, #F97316); }
.feed-card-nova::before { background: linear-gradient(180deg, #059669, #10B981); }
.feed-card-duda::before { background: linear-gradient(180deg, #D97706, #F59E0B); }
.feed-card-default::before { background: linear-gradient(180deg, #6B7280, #9CA3AF); }

.feed-card:hover {
  box-shadow: var(--feed-shadow-hover);
  border-color: var(--feed-primary-border);
}

.feed-card-expanded {
  border-color: var(--feed-primary-light);
  box-shadow: var(--feed-shadow-hover);
}

/* Card User */
.card-user {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.user-avatar-feed {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 1rem;
  flex-shrink: 0;
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-name {
  font-size: 0.9rem;
  display: block;
  line-height: 1.2;
}

.user-time {
  font-size: 0.75rem;
  color: var(--feed-text-secondary);
}

.card-badges {
  display: flex;
  gap: 0.35rem;
  flex-shrink: 0;
}

.badge-tipo {
  font-size: 0.7rem;
  padding: 0.2rem 0.5rem;
  border-radius: 999px;
  font-weight: 500;
}

.badge-tipo-sugestao { background: #E0E7FF; color: #4338CA; }
.badge-tipo-bug { background: #FEE2E2; color: #DC2626; }
.badge-tipo-nova { background: #D1FAE5; color: #059669; }
.badge-tipo-duda { background: #FEF3C7; color: #D97706; }
.badge-tipo-default { background: #F3F4F6; color: #6B7280; }

[data-bs-theme="dark"] .badge-tipo-sugestao { background: #312E81; color: #A5B4FC; }
[data-bs-theme="dark"] .badge-tipo-bug { background: #7F1D1D; color: #FCA5A5; }
[data-bs-theme="dark"] .badge-tipo-nova { background: #065F46; color: #6EE7B7; }
[data-bs-theme="dark"] .badge-tipo-duda { background: #78350F; color: #FCD34D; }

.badge-admin-interno {
  font-size: 0.6rem;
  padding: 0.15rem 0.4rem;
  border-radius: 999px;
  background: #34495E;
  color: white;
  font-weight: 600;
  vertical-align: middle;
}

/* Card Body */
.card-body-feed {
  cursor: pointer;
  margin-bottom: 0.75rem;
}

.card-title-feed {
  font-size: 1.05rem;
  font-weight: 600;
  margin-bottom: 0.35rem;
  color: var(--feed-text);
}

.card-desc-feed {
  font-size: 0.875rem;
  color: var(--feed-text-secondary);
  margin-bottom: 0.25rem;
  line-height: 1.5;
}

/* Markdown da descrição (Pergunta/Resposta) — espaçamento compacto */
.card-desc-feed :deep(p) {
  margin: 0 0 0.25rem 0;
}

.card-desc-feed :deep(p:last-child) {
  margin-bottom: 0;
}

.card-desc-feed :deep(h3) {
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0.25rem 0 0.15rem 0;
}

.desc-collapsed {
  max-height: 3.5rem;
  overflow: hidden;
}

.card-desc-feed :deep(h3:first-child) {
  margin-top: 0;
}

.btn-expand-toggle {
  background: none;
  border: none;
  color: var(--feed-primary);
  font-size: 0.8rem;
  padding: 0;
  cursor: pointer;
  font-weight: 500;
}

.btn-expand-toggle:hover {
  text-decoration: underline;
}

/* Card Status */
.card-status-bar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.badge-status {
  font-size: 0.7rem;
  padding: 0.25rem 0.6rem;
  border-radius: 999px;
  font-weight: 500;
}

.badge-status-pendente { background: #FEF3C7; color: #D97706; }
.badge-status-analise { background: #DBEAFE; color: #2563EB; }
.badge-status-planejado { background: #E0E7FF; color: #4338CA; }
.badge-status-desenvolvimento { background: #F3E8FF; color: #7C3AED; }
.badge-status-concluido { background: #D1FAE5; color: #059669; }
.badge-status-rejeitado { background: #FEE2E2; color: #DC2626; }
.badge-status-banido { background: #6C757D; color: #FFFFFF; }

[data-bs-theme="dark"] .badge-status-pendente { background: #78350F; color: #FCD34D; }
[data-bs-theme="dark"] .badge-status-analise { background: #1E3A5F; color: #93C5FD; }
[data-bs-theme="dark"] .badge-status-planejado { background: #312E81; color: #A5B4FC; }
[data-bs-theme="dark"] .badge-status-desenvolvimento { background: #4C1D95; color: #C4B5FD; }
[data-bs-theme="dark"] .badge-status-concluido { background: #065F46; color: #6EE7B7; }
[data-bs-theme="dark"] .badge-status-rejeitado { background: #7F1D1D; color: #FCA5A5; }
[data-bs-theme="dark"] .badge-status-banido { background: #495057; color: #CED4DA; }

.card-modulo {
  font-size: 0.75rem;
  color: var(--feed-text-secondary);
}

.badge-prior {
  font-size: 0.65rem;
  padding: 0.15rem 0.45rem;
  border-radius: 999px;
  font-weight: 600;
}

.badge-prior-critica { background: #DC2626; color: white; }
.badge-prior-alta { background: #F59E0B; color: white; }
.badge-prior-media { background: #3B82F6; color: white; }
.badge-prior-baixa { background: #9CA3AF; color: white; }

/* Card Actions */
.card-actions {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  border-top: 1px solid var(--feed-card-border);
  padding-top: 0.75rem;
}

.btn-action {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.75rem;
  border: none;
  background: transparent;
  color: var(--feed-text-secondary);
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 500;
  transition: var(--feed-transition);
  cursor: pointer;
}

.btn-action:hover {
  background: var(--feed-primary-bg);
  color: var(--feed-primary);
}

.btn-action-active {
  color: var(--feed-primary);
  background: var(--feed-primary-bg);
}

.btn-action-admin {
  padding: 0.35rem 0.5rem;
  background: var(--feed-primary-bg);
  color: var(--feed-primary);
  border-radius: 8px;
}

.btn-action-admin:hover {
  background: var(--feed-primary);
  color: white;
}

/* ========================
   COMENTÁRIOS
   ======================== */
.card-comments {
  margin-top: 0.75rem;
  background: var(--bs-body-bg);
  border-radius: 10px;
  padding: 0.75rem 1rem;
  margin-left: 1rem;
}

.comments-divider {
  height: 1px;
  background: var(--feed-card-border);
  margin-bottom: 0.75rem;
}

.comments-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  max-height: 300px;
  overflow-y: auto;
}

.comment-item {
  display: flex;
  gap: 0.65rem;
}

.comment-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 0.7rem;
  flex-shrink: 0;
}

.comment-content {
  flex: 1;
  min-width: 0;
}

.comment-body {
  border: 2px solid transparent;
  border-radius: 8px;
  transition: border-color 0.4s ease-in, background 0.4s ease-in;
}

.comment-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.15rem;
}

.comment-author {
  font-size: 0.8rem;
}

.comment-time {
  font-size: 0.65rem;
  color: var(--feed-text-secondary);
}

.comment-text {
  font-size: 0.825rem;
  margin-bottom: 0.25rem;
  line-height: 1.4;
  word-break: break-word;
  white-space: pre-wrap;
}

.comment-actions {
  display: flex;
  gap: 0.5rem;
}

.btn-like-comment {
  background: none;
  border: none;
  padding: 0.15rem 0.4rem;
  font-size: 0.7rem;
  color: var(--feed-text-secondary);
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 0.2rem;
  transition: var(--feed-transition);
}

.btn-like-comment:hover {
  color: #E11D48;
  background: #FFF1F2;
}

.btn-like-comment.liked {
  color: #E11D48;
}

.btn-reply-comment {
  background: none;
  border: none;
  padding: 0.15rem 0.4rem;
  font-size: 0.7rem;
  color: var(--feed-text-secondary);
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 0.2rem;
  transition: var(--feed-transition);
}
.btn-reply-comment:hover {
  color: var(--feed-primary);
  background: var(--feed-primary-bg);
}

/* Botão Excluir Comentário (Admin) */
.btn-delete-comment {
  background: none;
  border: none;
  padding: 0.15rem 0.4rem;
  font-size: 0.7rem;
  color: var(--feed-text-secondary);
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 0.2rem;
  transition: var(--feed-transition);
}

.btn-delete-comment:hover {
  color: #DC2626;
  background: #FEE2E2;
}

.comment-replies {
  margin-left: 1.5rem;
  margin-top: 0.5rem;
  padding-left: 0.75rem;
  border-left: 2px solid var(--feed-primary-border);
}

.comment-replies-toggle {
  margin-left: 1.5rem;
  margin-top: 0.4rem;
}

.btn-ver-respostas {
  background: none;
  border: 1px solid var(--feed-primary-border);
  color: var(--feed-primary);
  font-size: 0.78rem;
  font-weight: 600;
  padding: 0.3rem 0.75rem;
  border-radius: 999px;
  cursor: pointer;
  transition: var(--feed-transition);
}

.btn-ver-respostas:hover {
  background: var(--feed-primary-bg);
  border-color: var(--feed-primary);
}

.btn-ver-mais-respostas {
  background: none;
  border: none;
  color: var(--feed-text-secondary);
  font-size: 0.75rem;
  padding: 0.4rem 0;
  cursor: pointer;
  transition: var(--feed-transition);
  width: 100%;
  text-align: center;
}

.btn-ver-mais-respostas:hover {
  color: var(--feed-primary);
}

.feed-comments-pagination {
  display: flex;
  justify-content: center;
  padding: 0.5rem 0;
  margin-top: 0.25rem;
}

/* ========================
   POPUP QUEM CURTIU
   ======================== */
.curtidores-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.3);
}

.curtidores-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--feed-card-bg);
  border: 1px solid var(--feed-card-border);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  width: 320px;
  max-width: 90vw;
  max-height: 60vh;
  display: flex;
  flex-direction: column;
}

.curtidores-popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.65rem 0.9rem;
  border-bottom: 1px solid var(--feed-card-border);
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--feed-primary);
}

.curtidores-popup-close {
  background: none;
  border: none;
  font-size: 1.3rem;
  line-height: 1;
  color: var(--feed-text-secondary);
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: var(--feed-transition);
}

.curtidores-popup-close:hover {
  background: var(--feed-primary-bg);
  color: var(--feed-text);
}

.curtidores-popup-body {
  overflow-y: auto;
  padding: 0.4rem;
  flex: 1;
}

.curtidores-popup-loading,
.curtidores-popup-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  color: var(--feed-text-secondary);
  font-size: 0.8rem;
}

.curtidores-popup-list {
  display: flex;
  flex-direction: column;
}

.curtidor-popup-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.5rem;
  border-radius: 8px;
  transition: var(--feed-transition);
}

.curtidor-popup-item:hover {
  background: var(--feed-primary-bg);
}

.curtidor-popup-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  flex-shrink: 0;
}

.curtidor-popup-avatar-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 0.65rem;
}

.curtidor-popup-nome {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--feed-text);
}

/* ========================
   BOTÕES DE CONTAGEM
   ======================== */
.btn-action-group {
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--feed-card-border);
  border-radius: 999px;
  overflow: hidden;
  transition: var(--feed-transition);
}

.btn-action-group:hover {
  border-color: var(--feed-primary);
}

.btn-action-group .btn-action {
  border: none;
  border-radius: 0;
  padding: 0.25rem 0.4rem 0.25rem 0.6rem;
}

.btn-action-group .btn-action-active {
  background: var(--feed-primary-bg);
}

.btn-action-count {
  background: none;
  border: none;
  border-left: 1px solid var(--feed-card-border);
  cursor: pointer;
  font-weight: 700;
  font-size: 0.78rem;
  min-width: 1.6rem;
  padding: 0.25rem 0.5rem;
  text-align: center;
  color: var(--feed-text-secondary);
  transition: var(--feed-transition);
}

.btn-action-group:hover .btn-action-count {
  border-left-color: var(--feed-primary);
  color: var(--feed-primary);
}

.btn-like-group {
  display: inline-flex;
  align-items: center;
  gap: 0;
  border: 1px solid transparent;
  border-radius: 999px;
  transition: var(--feed-transition);
}

.btn-like-group:hover {
  border-color: var(--feed-primary-border);
  background: var(--feed-primary-bg);
}

.btn-like-group .btn-like-comment {
  border: none;
  border-radius: 999px 0 0 999px;
  padding: 0.15rem 0.2rem 0.15rem 0.4rem;
}

.btn-like-count {
  background: none;
  border: none;
  border-left: 1px solid var(--feed-primary-border);
  border-radius: 0 999px 999px 0;
  cursor: pointer;
  font-weight: 700;
  font-size: 0.72rem;
  color: var(--feed-text-secondary);
  padding: 0.15rem 0.4rem 0.15rem 0.2rem;
  transition: var(--feed-transition);
}

.btn-like-group:hover .btn-like-count {
  color: var(--feed-primary);
}

.comment-item-reply {
  margin-bottom: 0.5rem;
}

.comment-reply-input-area {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.5rem;
  padding-left: 0.5rem;
}

.comment-highlight {
  /* Highlight gerenciado via JavaScript (watch) com box-shadow para não vazar do espaço */
  border-radius: 8px;
}

/* Comment Input */
.comment-input-area {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  position: relative;
}

.comment-input-wrapper {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
}

.comment-input-field {
  border-radius: 999px;
  padding-right: 2.5rem;
  font-size: 0.825rem;
  border: 1px solid var(--feed-card-border);
  transition: var(--feed-transition);
}

.comment-input-field:focus {
  border-color: var(--feed-primary);
  box-shadow: 0 0 0 0.2rem rgba(139, 92, 246, 0.12);
}

.btn-emoji-picker {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 1.1rem;
  cursor: pointer;
  padding: 2px 4px;
  line-height: 1;
  border-radius: 4px;
  transition: var(--feed-transition);
}

.btn-emoji-picker:hover {
  background: var(--feed-primary-bg);
}

.btn-send-comment {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--feed-primary);
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: var(--feed-transition);
  flex-shrink: 0;
}

.btn-send-comment:hover {
  background: var(--feed-primary-dark);
  transform: scale(1.05);
}

.btn-send-comment:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  transform: none;
}

/* @Menção Dropdown */
.mention-dropdown {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  background: var(--feed-card-bg);
  border: 1px solid var(--feed-card-border);
  border-radius: 12px;
  padding: 0.25rem;
  box-shadow: 0 8px 24px rgba(0,0,0,0.15);
  z-index: 100;
  min-width: 200px;
  max-height: 200px;
  overflow-y: auto;
}

.mention-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.6rem;
  cursor: pointer;
  border-radius: 8px;
  font-size: 0.85rem;
  transition: var(--feed-transition);
}

.mention-item:hover,
.mention-item-active {
  background: var(--feed-primary);
  color: white;
}

.mention-item-active .mention-tag {
  background: rgba(255,255,255,0.2);
  color: white;
}

.mention-avatar {
  flex-shrink: 0;
}

.mention-tag {
  margin-left: auto;
  font-size: 0.65rem;
  padding: 0.1rem 0.4rem;
  border-radius: 8px;
  background: var(--feed-primary-bg);
  color: var(--feed-primary);
  font-weight: 600;
  white-space: nowrap;
}

.mention-link {
  color: var(--feed-primary);
  font-weight: 600;
  text-decoration: none;
}

.mention-link:hover {
  text-decoration: underline;
}

.hashtag-link {
  color: var(--feed-primary);
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}

.hashtag-link:hover {
  text-decoration: underline;
}

/* Emoji Picker Popup */
.emoji-picker-popup {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  background: var(--feed-card-bg);
  border: 1px solid var(--feed-card-border);
  border-radius: 12px;
  padding: 0.5rem;
  box-shadow: 0 8px 24px rgba(0,0,0,0.15);
  z-index: 100;
  width: 240px;
}

.emoji-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 2px;
}

.emoji-item {
  background: none;
  border: none;
  font-size: 1.25rem;
  padding: 4px;
  cursor: pointer;
  border-radius: 6px;
  transition: var(--feed-transition);
  text-align: center;
}

.emoji-item:hover {
  background: var(--feed-primary-bg);
  transform: scale(1.2);
}

/* ========================
   PAGINAÇÃO
   ======================== */
.feed-pagination {
  text-align: center;
  padding: 1.5rem 0;
}

.btn-load-more {
  padding: 0.6rem 2rem;
  border-radius: 999px;
  font-size: 0.9rem;
}

/* ========================
   EMPTY STATE
   ======================== */
.feed-empty {
  text-align: center;
  padding: 3rem 1rem;
}

.empty-icon {
  font-size: 4rem;
  color: var(--feed-primary-light);
  opacity: 0.5;
  margin-bottom: 1rem;
}

.feed-empty h5 {
  color: var(--feed-text);
  margin-bottom: 0.5rem;
}

.feed-empty p {
  color: var(--feed-text-secondary);
  margin-bottom: 1.5rem;
}

/* ========================
   WIDGET: PIPELINE DE STATUS
   ======================== */
.widget-pipeline {
  border: 1px solid var(--feed-primary-border);
  background: linear-gradient(180deg, var(--feed-primary-bg), var(--feed-card-bg));
}

.pipeline-tiles {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.4rem;
}

.pipeline-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.15rem;
  padding: 0.5rem 0.2rem;
  border: 1px solid var(--feed-card-border);
  border-radius: 10px;
  background: var(--feed-card-bg);
  cursor: pointer;
  transition: var(--feed-transition);
  font-size: 0.65rem;
}

.pipeline-tile:hover {
  transform: translateY(-1px);
  box-shadow: var(--feed-shadow-hover);
}

.pipeline-tile-active {
  border-color: var(--feed-primary);
  box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.25);
}

.pipeline-tile-count {
  font-size: 1.15rem;
  font-weight: 800;
  line-height: 1;
}

.pipeline-tile-label {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  font-size: 0.6rem;
  white-space: nowrap;
}

.pipeline-tile-pendente { background: linear-gradient(135deg, #FEF3C7, #FDE68A); color: #92400E; }
.pipeline-tile-analise { background: linear-gradient(135deg, #DBEAFE, #BFDBFE); color: #1D4ED8; }
.pipeline-tile-planejado { background: linear-gradient(135deg, #E0E7FF, #C7D2FE); color: #3730A3; }
.pipeline-tile-desenvolvimento { background: linear-gradient(135deg, #F3E8FF, #E9D5FF); color: #6D28D9; }
.pipeline-tile-concluido { background: linear-gradient(135deg, #D1FAE5, #A7F3D0); color: #047857; }
.pipeline-tile-rejeitado { background: linear-gradient(135deg, #FEE2E2, #FECACA); color: #B91C1C; }

[data-bs-theme="dark"] .pipeline-tile-pendente { background: linear-gradient(135deg, #78350F, #92400E); color: #FCD34D; }
[data-bs-theme="dark"] .pipeline-tile-analise { background: linear-gradient(135deg, #1E3A5F, #1E40AF); color: #93C5FD; }
[data-bs-theme="dark"] .pipeline-tile-planejado { background: linear-gradient(135deg, #312E81, #3730A3); color: #A5B4FC; }
[data-bs-theme="dark"] .pipeline-tile-desenvolvimento { background: linear-gradient(135deg, #4C1D95, #5B21B6); color: #C4B5FD; }
[data-bs-theme="dark"] .pipeline-tile-concluido { background: linear-gradient(135deg, #065F46, #047857); color: #6EE7B7; }
[data-bs-theme="dark"] .pipeline-tile-rejeitado { background: linear-gradient(135deg, #7F1D1D, #991B1B); color: #FCA5A5; }

.pipeline-bar {
  display: flex;
  height: 8px;
  border-radius: 999px;
  overflow: hidden;
  margin-top: 0.5rem;
  background: var(--feed-card-border);
}

.pipeline-bar-segment {
  height: 100%;
}

.pipeline-bar-pendente { background: #F59E0B; }
.pipeline-bar-analise { background: #3B82F6; }
.pipeline-bar-planejado { background: #8B5CF6; }
.pipeline-bar-desenvolvimento { background: #A78BFA; }
.pipeline-bar-concluido { background: #10B981; }
.pipeline-bar-rejeitado { background: #EF4444; }

.pipeline-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin-top: 0.4rem;
}

.pipeline-legend-item {
  font-size: 0.6rem;
  color: var(--feed-text-secondary);
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
}

.pipeline-dot-pendente { color: #F59E0B; }
.pipeline-dot-analise { color: #3B82F6; }
.pipeline-dot-planejado { color: #8B5CF6; }
.pipeline-dot-desenvolvimento { color: #A78BFA; }
.pipeline-dot-concluido { color: #10B981; }
.pipeline-dot-rejeitado { color: #EF4444; }

/* ========================
   WIDGET: TOP VOTADOS PENDENTES
   ======================== */
.widget-top-votados {
  border: 1px solid var(--feed-primary-border);
  background: linear-gradient(180deg, #FFF7ED, var(--feed-card-bg));
}

.widget-top-votados .widget-title {
  color: var(--feed-ambar);
}

.top-votados-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.top-votado-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.45rem 0.6rem;
  border: 1px solid var(--feed-card-border);
  background: var(--feed-card-bg);
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  transition: var(--feed-transition);
}

.top-votado-item:hover {
  border-color: var(--feed-ambar);
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.2);
  transform: translateY(-1px);
}

.top-votado-rank {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 800;
  flex-shrink: 0;
  background: linear-gradient(135deg, #F59E0B, #F97316);
  color: white;
}

.rank-1 { background: linear-gradient(135deg, #F59E0B, #F97316); }
.rank-2 { background: linear-gradient(135deg, #9CA3AF, #6B7280); }
.rank-3 { background: linear-gradient(135deg, #B45309, #92400E); }
.rank-4, .rank-5 { background: linear-gradient(135deg, #FBBF24, #F59E0B); }

.top-votado-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.top-votado-titulo {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--feed-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.top-votado-meta {
  font-size: 0.65rem;
  color: var(--feed-text-secondary);
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.top-votado-votos {
  margin-left: auto;
  color: var(--feed-ambar);
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
}

.widget-empty {
  font-size: 0.75rem;
  color: var(--feed-text-secondary);
  padding: 0.5rem;
}

[data-bs-theme="dark"] .widget-top-votados {
  background: linear-gradient(180deg, #2D1B0E, var(--feed-card-bg));
}

[data-bs-theme="dark"] .widget-radar-equipe {
  background: linear-gradient(180deg, #0D1B2E, var(--feed-card-bg));
}

[data-bs-theme="dark"] .widget-feedback-recente {
  background: linear-gradient(180deg, #2D1D10, var(--feed-card-bg));
}

[data-bs-theme="dark"] .duvida-destaque-item,
[data-bs-theme="dark"] .topico-quente-item,
[data-bs-theme="dark"] .feedback-recente-item {
  background: var(--feed-card-bg);
  border-color: var(--feed-primary-border);
}

[data-bs-theme="dark"] .radar-item:hover {
  background: var(--feed-primary-bg);
}

/* ========================
   WIDGET: CAROUSEL 4 ESTÁGIOS
   ======================== */
.widget-carousel {
  border: 1px solid var(--feed-primary-border);
  background: linear-gradient(180deg, var(--feed-primary-bg), var(--feed-card-bg));
  position: relative;
  z-index: 1;
}

.carousel-indicators {
  display: flex;
  justify-content: center;
  gap: 0.4rem;
  margin-bottom: 0.6rem;
}

.carousel-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid var(--feed-primary-border);
  background: transparent;
  cursor: pointer;
  padding: 0;
  transition: all 0.2s ease;
}

.carousel-dot.active {
  background: var(--feed-primary);
  border-color: var(--feed-primary);
  transform: scale(1.2);
}

.carousel-stage {
  min-height: 260px;
  overflow: hidden;
  position: relative;
}

.carousel-track {
  display: flex;
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;
}

.carousel-slide {
  min-width: 100%;
  box-sizing: border-box;
}

.hashtags-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.hashtag-item {
  padding: 0.45rem 0.6rem;
  border: 1px solid var(--feed-card-border);
  background: var(--feed-card-bg);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.hashtag-item:hover {
  border-color: var(--feed-primary);
  box-shadow: 0 2px 8px rgba(139, 92, 246, 0.15);
  transform: translateY(-1px);
}

.hashtag-termo {
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--feed-primary);
}

.hashtag-score {
  font-size: 0.75rem;
  font-weight: 800;
  color: var(--feed-primary-deep);
  float: right;
}

.hashtag-count {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--feed-text-secondary);
  float: right;
}

.hashtag-bar {
  height: 4px;
  background: var(--feed-card-border);
  border-radius: 999px;
  overflow: hidden;
  margin-top: 0.25rem;
}

.hashtag-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--feed-primary), var(--feed-primary-light));
  border-radius: 999px;
  transition: width 0.3s ease;
}

.hashtag-details {
  font-size: 0.6rem;
  color: var(--feed-text-secondary);
  margin-top: 0.15rem;
}

/* ========================
   CONTEÚDO REUTILIZADO NO CAROUSEL
   ======================== */
.duvidas-destaque-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.duvida-destaque-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.45rem 0.6rem;
  border: 1px solid var(--feed-card-border);
  background: var(--feed-card-bg);
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  transition: var(--feed-transition);
}

.duvida-destaque-item:hover {
  border-color: var(--feed-rosa);
  box-shadow: 0 2px 8px rgba(236, 72, 153, 0.15);
  transform: translateY(-1px);
}

.duvida-destaque-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.duvida-destaque-titulo {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--feed-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.duvida-destaque-meta {
  font-size: 0.65rem;
  color: var(--feed-text-secondary);
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.duvida-destaque-stats {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.15rem;
  flex-shrink: 0;
}

.duvida-destaque-stat {
  font-size: 0.65rem;
  color: var(--feed-rosa);
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
}

.topicos-quentes-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.topico-quente-item {
  padding: 0.45rem 0.6rem;
  border: 1px solid var(--feed-card-border);
  background: var(--feed-card-bg);
  border-radius: 10px;
  cursor: pointer;
  transition: var(--feed-transition);
}

.topico-quente-item:hover {
  border-color: var(--feed-esmeralda);
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15);
  transform: translateY(-1px);
}

.topico-quente-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.25rem;
}

.topico-quente-termo {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--feed-text);
}

.topico-quente-score {
  font-size: 0.75rem;
  font-weight: 800;
  color: var(--feed-esmeralda);
}

.topico-quente-bar {
  height: 4px;
  background: var(--feed-card-border);
  border-radius: 999px;
  overflow: hidden;
  margin-bottom: 0.25rem;
}

.topico-quente-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--feed-esmeralda), #34D399);
  border-radius: 999px;
  transition: width 0.3s ease;
}

.topico-quente-details {
  display: flex;
  gap: 0.5rem;
  font-size: 0.6rem;
  color: var(--feed-text-secondary);
}

/* ========================
   WIDGET: RADAR DA EQUIPE (FASE 2)
   ======================== */
.widget-radar-equipe {
  border: 1px solid var(--feed-primary-border);
  background: linear-gradient(180deg, #EFF6FF, var(--feed-card-bg));
}

.widget-radar-equipe .widget-title {
  color: var(--feed-azul);
}

.radar-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  max-height: calc(5 * 3.2rem);
  overflow-y: auto;
}

.radar-item {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.4rem 0.5rem;
  border-radius: 10px;
  cursor: pointer;
  transition: var(--feed-transition);
}

.radar-item:hover {
  background: var(--feed-primary-bg);
}

.radar-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 0.7rem;
  color: white;
}

.radar-icon-criacao {
  background: var(--feed-esmeralda);
}

.radar-icon-comentario {
  background: var(--feed-azul);
}

.radar-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.radar-mensagem {
  font-size: 0.72rem;
  color: var(--feed-text);
  line-height: 1.3;
}

.radar-titulo {
  color: var(--feed-primary);
  font-weight: 500;
}

.radar-time {
  font-size: 0.6rem;
  color: var(--feed-text-secondary);
  margin-top: 0.1rem;
}

/* ========================
   WIDGET: FEEDBACK RECENTE (FASE 2)
   ======================== */
.widget-feedback-recente {
  border: 1px solid var(--feed-primary-border);
  background: linear-gradient(180deg, #FFF7ED, var(--feed-card-bg));
}

.widget-feedback-recente .widget-title {
  color: var(--feed-naranja);
}

.feedback-recente-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.feedback-recente-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.45rem 0.6rem;
  border: 1px solid var(--feed-card-border);
  background: var(--feed-card-bg);
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  transition: var(--feed-transition);
}

.feedback-recente-item:hover {
  border-color: var(--feed-naranja);
  box-shadow: 0 2px 8px rgba(249, 115, 22, 0.15);
  transform: translateY(-1px);
}

.feedback-recente-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.feedback-recente-titulo {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--feed-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.feedback-recente-preview {
  font-size: 0.65rem;
  color: var(--feed-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 180px;
}

/* ========================
   MODAL ADMIN
   ======================== */
.admin-form {
  padding: 0.5rem 0;
}

.feedback-modal-content {
  padding: 0.5rem 0;
}

.feedback-sugestao-titulo {
  font-size: 1rem;
  color: var(--feed-text);
}

.feedback-text {
  font-size: 0.9rem;
  color: var(--feed-text-secondary);
  line-height: 1.6;
  margin-top: 0.75rem;
  white-space: pre-wrap;
}

/* ========================
   RESPONSIVO
   ======================== */
@media (max-width: 1200px) {
  .feed-layout {
    grid-template-columns: minmax(0, 1fr) 300px;
  }
  .feed-sidebar-left {
    display: none;
  }
}

@media (max-width: 992px) {
  .feed-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .feed-sidebar-right {
    display: none;
  }
}

/* ========================
   DRAWERS (MOBILE)
   ======================== */
.feed-drawer-backdrop {
  position: fixed;
  top: var(--feed-header-h, 56px);
  left: 0;
  width: 100vw;
  height: calc(100vh - var(--feed-header-h, 56px));
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
}

.feed-drawer {
  position: fixed;
  top: var(--feed-header-h, 56px);
  height: calc(100vh - var(--feed-header-h, 56px));
  width: 300px;
  max-width: 85vw;
  background: var(--bs-body-bg);
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease;
  box-shadow: 0 0 20px rgba(0,0,0,0.15);
}

.feed-drawer-left {
  left: 0;
  transform: translateX(-100%);
}

.feed-drawer-left.feed-drawer-open {
  transform: translateX(0);
}

.feed-drawer-right {
  right: 0;
  transform: translateX(100%);
}

.feed-drawer-right.feed-drawer-open {
  transform: translateX(0);
}

.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--bs-border-color-translucent);
  flex-shrink: 0;
}

.drawer-title {
  font-size: 0.9rem;
}

.drawer-close {
  background: none;
  border: none;
  color: var(--bs-body-color);
  font-size: 1rem;
  padding: 0.25rem;
  cursor: pointer;
}

.drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: 0.5rem;
}

/* ========================
   TOP BAR FLUTUANTE (MOBILE)
   ======================== */
.feed-topbar {
  position: fixed;
  top: var(--feed-header-h, 56px);
  left: 0;
  right: 0;
  z-index: 1030;
  background: linear-gradient(135deg, var(--feed-primary-bg), var(--bs-body-bg));
  border-bottom: 2px solid var(--feed-primary-border);
  box-shadow: 0 2px 8px rgba(139, 92, 246, 0.1);
  padding: 0.5rem 0.75rem;
  transform: translateY(-100%);
  transition: transform 0.3s ease;
}

.feed-topbar.feed-topbar-visible {
  transform: translateY(0);
}

/* Sentinela invisível no topo do feed (para IntersectionObserver) */
.feed-sentinel-top {
  height: 1px;
  width: 100%;
  pointer-events: none;
}

/* Layout em 2 linhas: label + ações no topo, filtros abaixo */
.topbar-row {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.topbar-row-top {
  margin-bottom: 0.35rem;
}

.topbar-row-filters {
  gap: 0.35rem;
}

.topbar-actions {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin-left: auto;
}

.topbar-label {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--feed-primary);
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  flex-shrink: 0;
}

.topbar-label .bi-question-circle {
  font-size: 0.65rem;
  opacity: 0.6;
  cursor: help;
}

.topbar-select {
  border: 1px solid var(--bs-border-color);
  border-radius: 999px;
  padding: 0.3rem 0.5rem;
  font-size: 0.75rem;
  background: var(--bs-tertiary-bg);
  color: var(--bs-body-color);
  outline: none;
  max-width: 100px;
  cursor: pointer;
  flex: 1;
  min-width: 0;
}

.topbar-search {
  flex: 1.5;
  min-width: 80px;
  border: 1px solid var(--bs-border-color);
  border-radius: 999px;
  padding: 0.3rem 0.75rem;
  font-size: 0.8rem;
  background: var(--bs-tertiary-bg);
  color: var(--bs-body-color);
  outline: none;
}

.topbar-search:focus {
  border-color: var(--feed-primary);
}

.topbar-btn {
  background: none;
  border: 1px solid var(--bs-border-color);
  border-radius: 50%;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--bs-body-color);
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.15s ease;
  flex-shrink: 0;
}

.topbar-btn:hover {
  background: var(--bs-tertiary-bg);
}

.topbar-btn-refresh {
  color: var(--feed-primary);
  border-color: var(--feed-primary-border);
}

.topbar-btn-refresh:hover {
  background: var(--feed-primary-bg);
  color: var(--feed-primary-dark);
}

/* ========================
   FABS MOBILE
   ======================== */
.feed-fabs {
  position: fixed;
  bottom: 70px;
  left: 0;
  right: 0;
  pointer-events: none;
  z-index: 1020;
}

.feed-fab {
  position: fixed;
  bottom: 70px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid var(--bs-border-color);
  background: var(--bs-body-bg);
  color: var(--bs-body-color);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  pointer-events: auto;
  z-index: 1020;
}

.feed-fab:active {
  transform: scale(0.92);
}

.feed-fab-left {
  left: 12px;
}

.feed-fab-right {
  right: 12px;
}

.feed-fabs {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.feed-fabs.feed-fabs-hidden {
  opacity: 0;
  transform: translateY(16px);
  pointer-events: none;
}

[data-bs-theme="dark"] .feed-fab {
  background: var(--bs-tertiary-bg);
  border-color: var(--bs-border-color);
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
}

/* ========================
   FEED LAYOUT MOBILE
   ======================== */
.feed-layout-mobile {
  grid-template-columns: 1fr !important;
}

.feed-layout-mobile .feed-sidebar-left,
.feed-layout-mobile .feed-sidebar-right {
  display: none !important;
}
</style>

<!-- ========================================================================
     NON-SCOPED: Garante que CSS variables funcionem no conteúdo teleportado
     (Teleport to="body" move o DOM para fora de .sugestoes-feed, então as
     variáveis definidas no escopo não são herdadas pelo popup de curtidores)
     ======================================================================== -->
<style>
.curtidores-backdrop {
  --feed-card-bg: var(--bs-body-bg);
  --feed-card-border: var(--bs-border-color-translucent);
  --feed-primary: #8B5CF6;
  --feed-primary-light: #A78BFA;
  --feed-primary-dark: #7C3AED;
  --feed-primary-deep: #6D28D9;
  --feed-primary-bg: #F5F3FF;
  --feed-primary-border: #DDD6FE;
  --feed-text: var(--bs-body-color);
  --feed-text-secondary: var(--bs-secondary-color);
  --feed-shadow: 0 1px 3px rgba(0,0,0,0.08);
  --feed-transition: all 0.2s ease;
}

[data-bs-theme="dark"] .curtidores-backdrop {
  --feed-primary-bg: #1E1B2E;
  --feed-primary-border: #2D2840;
  --feed-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

/* ========================
   DRAWER DIREITO - WIDGETS (MOBILE)
   ======================== */
.feed-drawer-right .sidebar-widget {
  background: var(--bs-tertiary-bg);
  border-radius: 10px;
  padding: 0.75rem;
  margin-bottom: 0.75rem;
  border: 1px solid var(--bs-border-color-translucent);
}

.feed-drawer-right .widget-title {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--feed-primary, #8B5CF6);
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  border-left: 3px solid var(--feed-primary, #8B5CF6);
  padding-left: 0.5rem;
}

.feed-drawer-right .widget-title i {
  color: var(--feed-primary, #8B5CF6);
}

.feed-drawer-right .pipeline-tiles {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.3rem;
}

.feed-drawer-right .pipeline-tile {
  padding: 0.4rem;
  border-radius: 8px;
  border: 1px solid var(--bs-border-color);
  background: var(--bs-body-bg);
  text-align: center;
  cursor: pointer;
  transition: all 0.15s ease;
}

.feed-drawer-right .pipeline-tile-count {
  font-size: 1rem;
  font-weight: 700;
  display: block;
}

.feed-drawer-right .pipeline-tile-label {
  font-size: 0.65rem;
  display: block;
  margin-top: 0.1rem;
}

.feed-drawer-right .top-votados-list {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.feed-drawer-right .top-votado-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem;
  border-radius: 8px;
  border: 1px solid transparent;
  background: var(--bs-body-bg);
  cursor: pointer;
  transition: all 0.15s ease;
  text-align: left;
  width: 100%;
}

.feed-drawer-right .top-votado-rank {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 700;
  flex-shrink: 0;
}

.feed-drawer-right .rank-1 { background: #F59E0B; color: #fff; }
.feed-drawer-right .rank-2 { background: #9CA3AF; color: #fff; }
.feed-drawer-right .rank-3 { background: #D97706; color: #fff; }

.feed-drawer-right .top-votado-content {
  min-width: 0;
  flex: 1;
}

.feed-drawer-right .top-votado-titulo {
  font-size: 0.75rem;
  font-weight: 600;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.feed-drawer-right .top-votado-meta {
  font-size: 0.65rem;
  color: var(--bs-secondary-color);
}

.feed-drawer-right .carousel-indicators {
  display: flex;
  gap: 0.3rem;
  justify-content: center;
  margin-bottom: 0.4rem;
}

.feed-drawer-right .carousel-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: none;
  background: var(--bs-border-color);
  cursor: pointer;
  padding: 0;
}

.feed-drawer-right .carousel-dot.active {
  background: var(--feed-primary, #8B5CF6);
}

.feed-drawer-right .radar-list {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.feed-drawer-right .radar-item {
  display: flex;
  gap: 0.4rem;
  padding: 0.35rem;
  border-radius: 8px;
  background: var(--bs-body-bg);
  cursor: pointer;
  transition: all 0.15s ease;
}

.feed-drawer-right .radar-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 0.7rem;
}

.feed-drawer-right .radar-icon-criacao { background: rgba(139, 92, 246, 0.15); color: #8B5CF6; }
.feed-drawer-right .radar-icon-comentario { background: rgba(59, 130, 246, 0.15); color: #3B82F6; }

.feed-drawer-right .radar-content {
  min-width: 0;
  flex: 1;
}

.feed-drawer-right .radar-mensagem {
  font-size: 0.7rem;
  display: block;
}

.feed-drawer-right .radar-time {
  font-size: 0.6rem;
  color: var(--bs-secondary-color);
}

.feed-drawer-right .widget-empty {
  font-size: 0.7rem;
  color: var(--bs-secondary-color);
  text-align: center;
  padding: 0.5rem;
}

[data-bs-theme="dark"] .feed-drawer-right .sidebar-widget {
  background: var(--bs-secondary-bg);
  border-color: var(--bs-border-color);
}

[data-bs-theme="dark"] .feed-drawer-right .pipeline-tile,
[data-bs-theme="dark"] .feed-drawer-right .top-votado-item,
[data-bs-theme="dark"] .feed-drawer-right .radar-item {
  background: var(--bs-tertiary-bg);
}

/* ========================
   DENÚNCIAS (FASE 3)
   ======================== */
.btn-action-report {
  padding: 0.35rem 0.5rem;
  background: transparent;
  color: var(--feed-text-secondary);
  border-radius: 8px;
}
.btn-action-report:hover {
  background: #FEE2E2;
  color: #DC2626;
}
.denuncia-form {
  padding: 0.5rem 0;
}
.widget-moderacao {
  border: 1px solid #FECACA;
  background: linear-gradient(180deg, #FEF2F2, var(--feed-card-bg));
}
.widget-moderacao .widget-title,
.widget-moderacao .sidebar-title {
  color: #DC2626;
}
.moderacao-badge {
  background: #DC2626;
  color: white;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  display: inline-block;
  margin-bottom: 0.5rem;
}

/* ===== Widget Moderação - Lista ===== */
.moderacao-list {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}
.moderacao-item {
  display: flex;
  flex-direction: column;
  background: rgba(220, 38, 38, 0.08);
  border: 1px solid rgba(220, 38, 38, 0.2);
  border-radius: 8px;
  padding: 0.4rem 0.6rem;
  cursor: pointer;
  transition: var(--feed-transition);
  text-align: left;
  width: 100%;
}
.moderacao-item:hover {
  background: rgba(220, 38, 38, 0.15);
}
.moderacao-item-motivo {
  font-size: 0.7rem;
  font-weight: 700;
  color: #DC2626;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.moderacao-item-titulo {
  font-size: 0.75rem;
  color: var(--bs-body-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.moderacao-mais {
  font-size: 0.7rem;
  color: #DC2626;
  text-align: center;
  padding: 0.2rem;
  font-weight: 600;
}

/* ===== Badge de Denúncia no Card ===== */
.badge-denuncia {
  background-color: #DC2626;
  color: white;
  font-size: 0.65rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
}
.badge-denuncia i {
  font-size: 0.6rem;
}

/* ===== Botão de Moderação no Card ===== */
.btn-action-moderation {
  color: #DC2626;
  opacity: 0.6;
  transition: var(--feed-transition);
}
.btn-action-moderation:hover {
  opacity: 1;
  background: rgba(220, 38, 38, 0.1);
}
.btn-action-moderation.has-pending {
  opacity: 1;
}

/* ===== Chip de filtro Denúncias ===== */
.chip-denuncias {
  background: rgba(220, 38, 38, 0.12);
  border: 1px solid rgba(220, 38, 38, 0.3);
  color: #DC2626;
}
.chip-banidas {
  background: rgba(108, 117, 125, 0.12);
  border: 1px solid rgba(108, 117, 125, 0.3);
  color: #6C757D;
}

/* ===== Reports Modal ===== */
.reports-modal-body {
  padding: 0.25rem 0;
}
.reports-header {
  background: var(--bs-tertiary-bg);
  padding: 0.6rem 0.8rem;
  border-radius: 8px;
  margin-bottom: 0.8rem;
  font-size: 0.85rem;
  display: flex;
  gap: 0.5rem;
}
.reports-bulk-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.4rem 0.6rem;
  background: var(--bs-secondary-bg);
  border-radius: 6px;
  margin-bottom: 0.6rem;
  font-size: 0.8rem;
}
.reports-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 350px;
  overflow-y: auto;
  margin-bottom: 1rem;
}
.report-item {
  display: flex;
  gap: 0.6rem;
  padding: 0.6rem 0.8rem;
  border: 1px solid var(--bs-border-color);
  border-radius: 8px;
  background: var(--bs-body-bg);
  transition: var(--feed-transition);
}
.report-item-pendente {
  border-color: rgba(220, 38, 38, 0.3);
  background: rgba(220, 38, 38, 0.03);
}
.report-check {
  display: flex;
  align-items: flex-start;
  padding-top: 0.2rem;
}
.report-check input {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.report-content {
  flex: 1;
  min-width: 0;
}
.report-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.2rem;
}
.report-motivo {
  font-size: 0.85rem;
}
.report-descricao {
  font-size: 0.8rem;
  color: var(--bs-secondary-color);
  margin: 0.2rem 0;
}
.report-denunciante {
  font-size: 0.8rem;
  color: var(--bs-body-color);
  margin-top: 0.15rem;
}
.report-data {
  font-size: 0.7rem;
  color: var(--bs-secondary-color);
  margin-top: 0.15rem;
}
.report-observacao {
  font-size: 0.75rem;
  color: var(--bs-info);
  margin-top: 0.25rem;
  padding: 0.25rem 0.5rem;
  background: rgba(13, 110, 253, 0.06);
  border-radius: 4px;
}

/* ===== Área de Tratamento (Reports Modal) ===== */
.reports-treatment {
  border-top: 1px solid var(--bs-border-color);
  padding-top: 0.8rem;
  margin-top: 0.5rem;
}
.treatment-title {
  font-size: 0.9rem;
  color: var(--bs-info);
  margin-bottom: 0.4rem;
}
.treatment-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  margin-top: 0.4rem;
}
.treatment-check {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.82rem;
  cursor: pointer;
}
.treatment-check input {
  width: 15px;
  height: 15px;
  cursor: pointer;
}
.treatment-status-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.treatment-label {
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
}
.treatment-info {
  margin-top: 0.5rem;
  padding: 0.4rem 0.6rem;
  background: rgba(13, 110, 253, 0.06);
  border-radius: 6px;
  border-left: 3px solid var(--bs-info);
}

/* ===== Denúncias Tratadas ===== */
.reports-treated {
  margin-top: 1rem;
  padding-top: 0.5rem;
  border-top: 2px dashed var(--bs-border-color);
}
.report-item-treated {
  opacity: 0.7;
  background: var(--bs-tertiary-bg);
  border-color: var(--bs-border-color);
  pointer-events: none;
}
.report-item-treated .report-motivo {
  text-decoration: line-through;
  opacity: 0.6;
}
.report-done-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--bs-success);
  color: white;
  font-size: 0.7rem;
  margin-top: 0.2rem;
}
</style>
